[
  {
    "id": "affliction",
    "name": "Affliction",
    "type": "attack",
    "baseCost": 1,
    "action": "standard",
    "range": "close",
    "duration": "instant",
    "description": "Imposes debilitating conditions on a target for 1 PP/rank. Choose one condition for each of the three possible degrees of failure when the effect is acquired. Target resists with Fortitude or Will. Higher-degree conditions replace lower ones.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "resistance",
        "label": "Resistance Type",
        "control": "dropdown",
        "required": true,
        "options": [
          {
            "value": "fortitude",
            "label": "Fortitude",
            "description": "Physical resistance - used for poisons, diseases, physical afflictions",
            "i18n": {
              "pt-BR": {
                "label": "Fortitude",
                "description": "Resistência física — usada para venenos, doenças e aflições físicas"
              }
            }
          },
          {
            "value": "will",
            "label": "Will",
            "description": "Mental resistance - used for mental effects, emotions, mind control",
            "i18n": {
              "pt-BR": {
                "label": "Vontade",
                "description": "Resistência mental — usada para efeitos mentais, emoções e controle mental"
              }
            }
          }
        ],
        "i18n": {
          "pt-BR": {
            "label": "Tipo de Resistência"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Aflição",
        "description": "Impõe condições debilitantes ao alvo por 1 PP/rank. Escolha uma condição para cada um dos três graus possíveis de falha ao adquirir o efeito. O alvo resiste com Fortitude ou Vontade. Condições de graus superiores substituem as inferiores."
      }
    },
    "longDescription": "Affliction attacks impose debilitating conditions and always have a base cost of 1 PP/rank. Choose one condition for each degree of failure when the effect is acquired: first degree (dazed, entranced, fatigued, hindered, impaired, or vulnerable), second degree (compelled, defenseless, disabled, exhausted, immobile, prone, or stunned), and third degree (asleep, controlled, incapacitated, paralyzed, transformed, or unaware). These are resistance-check results, not separately purchased cost tiers. Higher-degree conditions replace lower ones. Target resists with Fortitude or Will (chosen at acquisition). Reference: Hero's Handbook p.149",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "cumulative",
        "name": "Cumulative",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Cumulative Affliction: failed saves stack. Each failure adds a degree even after full recovery.",
        "longDescription": "In a Cumulative Affliction, multiple failed resistance checks result in additional degrees of the condition, regardless of previous recovery. The target does not recover from prior degrees before new ones are applied.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Cumulativo",
            "description": "Aflição Cumulativa: falhas acumulam. Cada falha adiciona um grau mesmo após recuperação completa.",
            "longDescription": "Numa Aflição Cumulativa, múltiplas falhas nos testes de resistência resultam em graus adicionais da condição, independentemente de recuperação anterior."
          }
        }
      },
      {
        "id": "extra_condition",
        "name": "Extra Condition",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "repeatable": true,
        "description": "Adds one simultaneous condition at each active degree of Affliction per purchase.",
        "longDescription": "Extra Condition adds another simultaneous condition at each active degree. One purchase allows two conditions per degree, two purchases allow three. Variable Conditions is a separate modifier for choosing conditions when using the effect.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Condição Extra",
            "description": "Adiciona uma condição simultânea em cada grau ativo da Aflição por compra.",
            "longDescription": "Condição Extra acrescenta outra condição simultânea em cada grau ativo. Uma compra permite duas condições por grau; duas compras permitem três. Condições Variáveis é um modificador separado para escolher condições ao usar o efeito."
          }
        }
      },
      {
        "id": "progressive",
        "name": "Progressive",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "Target loses one degree per round even after initial resistance success.",
        "longDescription": "A Progressive Affliction worsens over time. Even if the target succeeds on their initial resistance check, they still worsen by one degree at the end of each round until they succeed on a resistance check or reach the maximum degree.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Progressivo",
            "description": "O alvo perde um grau por rodada mesmo após sucesso na resistência inicial.",
            "longDescription": "Uma Aflição Progressiva piora com o tempo. Mesmo que o alvo tenha sucesso no teste inicial, ainda piora um grau ao fim de cada rodada até ter sucesso ou atingir o grau máximo."
          }
        }
      },
      {
        "id": "alternate_resistance",
        "name": "Alternate Resistance",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Some Afflictions may be initially resisted by Dodge. Later resistance checks are typically still Fortitude or Will.",
        "longDescription": "Some Afflictions may be initially resisted by Dodge, representing the need for quick reaction time or reflexes to avoid the effect. In this case, the later resistance checks to remove the Affliction's conditions are typically still based on Fortitude or Will. For example, a target might make a Dodge check to avoid a blinding light or spray of liquid, but a Fortitude check to eliminate the effect if the initial Dodge fails.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "concentration_affliction",
        "name": "Concentration",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Once you hit, so long as you take a standard action each turn to maintain, the target must make a new resistance check with no attack check required.",
        "longDescription": "Once you have hit with a Concentration Affliction, so long as you continue to take a standard action each turn to maintain the effect, the target must make a new resistance check against it, with no attack check required.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "variable_conditions",
        "name": "Variable Conditions",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "Choose conditions when using Affliction. Power Profiles p. 80. All degrees.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Condições Variáveis",
            "description": "Escolha as condições ao usar Aflição. Power Profiles p. 80. Todos os graus."
          }
        }
      },
      {
        "id": "variable_condition_degree",
        "name": "Variable Condition Degree",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Choose conditions when using Affliction. Power Profiles p. 80. One chosen degree only.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Um Grau de Condição Variável",
            "description": "Escolha as condições ao usar Aflição. Power Profiles p. 80. Apenas um grau escolhido."
          }
        }
      },
      {
        "id": "merge_with_subject",
        "name": "Merge with Subject",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Power Profiles, Possession p. 129: user merges into the subject.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Fundir-se ao Alvo",
            "description": "Power Profiles, Possessão p. 129: usuário se funde ao alvo."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "instant_recovery",
        "name": "Instant Recovery",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Target recovers instantly after completing their resistance check.",
        "longDescription": "The target of an Instant Recovery Affliction recovers from all conditions as soon as they succeed on a resistance check, rather than waiting for the normal recovery time.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Recuperação Instantânea",
            "description": "O alvo se recupera instantaneamente após completar o teste de resistência.",
            "longDescription": "O alvo de uma Aflição com Recuperação Instantânea se recupera de todas as condições assim que tiver sucesso no teste de resistência."
          }
        }
      },
      {
        "id": "limited_degree",
        "name": "Limited Degree",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "maxRanks": 2,
        "repeatable": true,
        "description": "The Affliction only has one or two degrees instead of three.",
        "longDescription": "A Limited Degree Affliction inflicts conditions from only one (-2/rank) or two (-1/rank) degrees rather than three. Choose which degrees at acquisition.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Graus Limitados",
            "description": "A Aflição tem apenas um ou dois graus em vez de três.",
            "longDescription": "Uma Aflição com Graus Limitados inflige condições de apenas um (-2/rank) ou dois (-1/rank) graus. Escolha quais graus na aquisição."
          }
        }
      }
    ]
  },
  {
    "id": "burrowing",
    "name": "Burrowing",
    "type": "movement",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can burrow through the ground, leaving a tunnel behind if you choose. You move through soil and sand at a speed rank equal to your Burrowing rank minus 5. Hard clay reduces speed by an additional rank; solid rock reduces it by two additional ranks.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Escavação",
        "description": "Permite escavar pelo solo, deixando um túnel se desejar. Você se move através de terra e areia a uma velocidade igual ao rank de Escavação menos 5. Argila dura reduz a velocidade em um rank adicional; rocha sólida reduz em dois ranks adicionais."
      }
    },
    "longDescription": "You can burrow through the ground, leaving a tunnel behind if you choose. You move through soil and sand at a speed rank equal to your Burrowing rank minus 5. Hard clay reduces speed by an additional rank; solid rock reduces it by two additional ranks.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "penetrating",
        "name": "Penetrating",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Dig through super-hard materials.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Penetrante",
            "description": "Escava através de materiais super-duros."
          }
        }
      },
      {
        "id": "ranged",
        "name": "Ranged",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Create tunnels at a distance or grant to others at range.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "À Distância",
            "description": "Cria túneis à distância ou concede o efeito a outros."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "limited",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Limited to specific materials (e.g., loose sand, snow).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "Limitado a materiais específicos."
          }
        }
      }
    ]
  },
  {
    "id": "communication",
    "name": "Communication",
    "type": "sensory",
    "baseCost": 4,
    "action": "free",
    "range": "ranged",
    "duration": "sustained",
    "description": "You can communicate over a distance using a medium other than your voice. Choose a sense type as your medium (visual, auditory, olfactory, tactile, radio, or mental). Rank determines range: 1 = close (100 ft), 2 = 1 mile, 3 = statewide, 4 = worldwide, 5 = unlimited. Communication is language-dependent and point-to-point.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Comunicação",
        "description": "Permite comunicar-se à distância usando um meio diferente da voz. Escolha um tipo de sentido como meio (visual, auditivo, olfativo, tátil, rádio ou mental). O rank determina o alcance: 1 = perto (30 m), 2 = 1,5 km, 3 = estadual, 4 = mundial, 5 = ilimitado. A comunicação depende de idioma e é ponto a ponto."
      }
    },
    "longDescription": "You can communicate over a distance using a medium other than your voice. Choose a sense type as your medium (visual, auditory, olfactory, tactile, radio, or mental). Rank determines range: 1 = close (100 ft), 2 = 1 mile, 3 = statewide, 4 = worldwide, 5 = unlimited. Communication is language-dependent and point-to-point.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "area",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Broadcast omni-directionally to all receivers in range.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Área",
            "description": "Transmissão omnidirecional para todos no alcance."
          }
        }
      },
      {
        "id": "dimensional",
        "name": "Dimensional",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Communicate across dimensional barriers.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Dimensional",
            "description": "Comunica-se através de barreiras dimensionais."
          }
        }
      },
      {
        "id": "rapid",
        "name": "Rapid",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Communication is 10x faster per rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Rápido",
            "description": "Comunicação 10x mais rápida por rank."
          }
        }
      },
      {
        "id": "selective",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Choose specific receivers within an Area Communication.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Escolhe receptores específicos em uma Comunicação de Área."
          }
        }
      },
      {
        "id": "subtle",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Encrypted (1 rank) or undetectable (2 ranks).",
        "maxRanks": 2,
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sutil",
            "description": "Criptografado ou indetectável."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "limited",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Only members of a particular group.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "Apenas membros de um grupo específico."
          }
        }
      }
    ]
  },
  {
    "id": "comprehend",
    "name": "Comprehend",
    "type": "sensory",
    "baseCost": 2,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You can comprehend different sorts of communication. Each rank allows one option: understand or speak to animals (2 ranks for both), understand or speak languages (2 for both, 3 for universal, +1 for reading), communicate with machines (2 ranks), objects (2 ranks), plants (2 ranks), or spirits (1-2 ranks).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Compreensão",
        "description": "Permite compreender diferentes formas de comunicação. Cada rank permite uma opção: entender ou falar com animais (2 ranks para ambos), entender ou falar idiomas (2 para ambos, 3 para universal, +1 para ler), comunicar-se com máquinas (2 ranks), objetos (2 ranks), plantas (2 ranks), ou espíritos (1-2 ranks)."
      }
    },
    "longDescription": "You can comprehend different sorts of communication. Each rank allows one option: understand or speak to animals (2 ranks for both), understand or speak languages (2 for both, 3 for universal, +1 for reading), communicate with machines (2 ranks), objects (2 ranks), plants (2 ranks), or spirits (1-2 ranks).",
    "enhancesDefense": null,
    "extras": [],
    "flaws": [
      {
        "id": "type_broad",
        "name": "Type (Broad)",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only comprehend a broad type of subject (only elves, canines, avians, or sea creatures, for example).",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "type_narrow",
        "name": "Type (Narrow)",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -2,
        "description": "You can only comprehend a narrow type of subject (dogs, falcons, or dolphins, for example).",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "concealment",
    "name": "Concealment",
    "type": "sensory",
    "baseCost": 2,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You gain total concealment from a particular sense while active. Each additional rank gives concealment from another sense; two ranks cover an entire sense type. Visual concealment costs double (2 ranks for one visual sense, 4 for all visual). Cannot conceal from tactile senses (requires Insubstantial). Concealment 10 = total concealment from all non-tactile senses.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "senses",
        "label": "Concealed Senses",
        "control": "multiselect",
        "required": true,
        "options": [
          {
            "value": "visual",
            "label": "Visual (costs 2 ranks per sense)",
            "description": "Invisible to sight"
          },
          {
            "value": "auditory",
            "label": "Auditory",
            "description": "Silent, cannot be heard"
          },
          {
            "value": "olfactory",
            "label": "Olfactory",
            "description": "No scent"
          },
          {
            "value": "radio",
            "label": "Radio",
            "description": "Undetectable by radio/radar"
          },
          {
            "value": "mental",
            "label": "Mental",
            "description": "Undetectable by mental senses"
          }
        ],
        "i18n": {
          "pt-BR": {
            "label": "Sentidos Ocultos"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Camuflagem",
        "description": "Concede ocultação total de um sentido específico enquanto ativo. Cada rank adicional concede ocultação de outro sentido; dois ranks cobrem um tipo de sentido inteiro. Ocultação visual custa o dobro (2 ranks para um sentido visual, 4 para todos). Não é possível ocultar-se do tato (requer Insubstancial). Camuflagem 10 = ocultação total de todos os sentidos não-táteis."
      }
    },
    "longDescription": "You gain total concealment from a particular sense while active. Each additional rank gives concealment from another sense; two ranks cover an entire sense type. Visual concealment costs double (2 ranks for one visual sense, 4 for all visual). Cannot conceal from tactile senses (requires Insubstantial). Concealment 10 = total concealment from all non-tactile senses.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "affects_others",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Grant Concealment to others via touch.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Outros",
            "description": "Concede Camuflagem a outros por toque."
          }
        }
      },
      {
        "id": "area",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Affects everything in the area.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Área",
            "description": "Afeta tudo na área."
          }
        }
      },
      {
        "id": "attack",
        "name": "Attack",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Impose Concealment on others.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Ataque",
            "description": "Impõe Camuflagem a outros."
          }
        }
      },
      {
        "id": "precise",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Vary Concealment from total to partial at will.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Preciso",
            "description": "Varia Camuflagem de total a parcial à vontade."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "blending",
        "name": "Blending",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Only functions while moving slowly.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Mesclar",
            "description": "Funciona apenas se movendo devagar."
          }
        }
      },
      {
        "id": "limited",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Works only under certain conditions (e.g., in shadows).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "Funciona apenas sob certas condições."
          }
        }
      },
      {
        "id": "partial",
        "name": "Partial",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Provides partial concealment (-2 to Perception).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Parcial",
            "description": "Concede camuflagem parcial."
          }
        }
      },
      {
        "id": "passive",
        "name": "Passive",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Ends if you make an attack or effect check.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Passivo",
            "description": "Acaba se você fizer um ataque ou teste de efeito."
          }
        }
      },
      {
        "id": "resistible",
        "name": "Resistible",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Offers a resistance check for anyone looking for you.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Resistível",
            "description": "Oferece teste de resistência a quem procurar."
          }
        }
      }
    ]
  },
  {
    "id": "create",
    "name": "Create",
    "type": "control",
    "baseCost": 2,
    "action": "standard",
    "range": "ranged",
    "duration": "sustained",
    "description": "You can form solid objects out of nowhere (solidified energy, hardened water, ice, stone, etc.). Create simple geometric shapes or common objects. Maximum volume rank and Toughness equal to your effect rank. Objects vanish when you stop maintaining. Can trap targets inside hollow objects (requires attack check vs. Dodge and Dodge resistance check vs. rank).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Criação",
        "description": "Permite criar objetos sólidos do nada (energia solidificada, água endurecida, gelo, pedra, etc.). Crie formas geométricas simples ou objetos comuns. Volume máximo e Resistência iguais ao rank do efeito. Os objetos desaparecem quando você para de mantê-los. Pode prender alvos dentro de objetos ocos (requer teste de ataque vs. Esquiva e teste de resistência de Esquiva vs. rank)."
      }
    },
    "longDescription": "You can form solid objects out of nowhere (solidified energy, hardened water, ice, stone, etc.). Create simple geometric shapes or common objects. Maximum volume rank and Toughness equal to your effect rank. Objects vanish when you stop maintaining. Can trap targets inside hollow objects (requires attack check vs. Dodge and Dodge resistance check vs. rank).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "continuous",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Objects remain until destroyed, nullified, or dismissed.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Contínuo",
            "description": "Objetos permanecem até serem destruídos ou desfeitos."
          }
        }
      },
      {
        "id": "impervious",
        "name": "Impervious",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "The object's Toughness is Impervious.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Impenetrável",
            "description": "A Resistência do objeto é Impenetrável."
          }
        }
      },
      {
        "id": "innate",
        "name": "Innate",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Objects are real and cannot be nullified.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Inato",
            "description": "Objetos são reais e não podem ser anulados."
          }
        }
      },
      {
        "id": "movable",
        "name": "Movable",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can move your created objects (as Move Object).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Móvel",
            "description": "Você pode mover os objetos criados."
          }
        }
      },
      {
        "id": "precise",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Create detailed objects and moving parts.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Preciso",
            "description": "Cria objetos detalhados e com partes móveis."
          }
        }
      },
      {
        "id": "selective",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can make objects selectively transparent to attacks or solid to some creatures.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Permite tornar objetos seletivamente sólidos ou transparentes."
          }
        }
      },
      {
        "id": "stationary",
        "name": "Stationary",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Objects hang immobile in the air.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Estacionário",
            "description": "Objetos ficam suspensos no ar."
          }
        }
      },
      {
        "id": "subtle",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Objects look like real objects (1 rank) or are invisible (2 ranks).",
        "maxRanks": 2,
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sutil",
            "description": "Objetos parecem reais ou são invisíveis."
          }
        }
      },
      {
        "id": "tether",
        "name": "Tether",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "You can exert your own Strength to move the objects.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Conexão",
            "description": "Permite usar sua própria Força para mover objetos."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "feedback",
        "name": "Feedback",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You suffer damage when your objects are damaged.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Retroalimentação",
            "description": "Você sofre dano quando os objetos são danificados."
          }
        }
      },
      {
        "id": "permanent",
        "name": "Permanent",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Objects cannot be dismissed or repaired.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Permanente",
            "description": "Objetos não podem ser desfeitos ou reparados."
          }
        }
      },
      {
        "id": "proportional",
        "name": "Proportional",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Volume rank + Toughness rank = Create rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Proporcional",
            "description": "Rank de Volume + Resistência = Rank do efeito."
          }
        }
      }
    ]
  },
  {
    "id": "damage",
    "name": "Damage",
    "type": "attack",
    "baseCost": 1,
    "action": "standard",
    "range": "close",
    "duration": "instant",
    "description": "You inflict damage on a target via a close attack. Target resists with Toughness vs. DC [rank + 15]. One degree: -1 penalty to further Toughness checks. Two degrees: dazed + -1 penalty. Three degrees: staggered + -1 penalty. Four degrees: incapacitated. Penalties are cumulative. Incapacitated targets failing again become dying, then dead. Can be Strength-based to add Strength ranks to damage.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "damageBasis",
        "label": "Damage Basis",
        "control": "dropdown",
        "required": false,
        "options": [
          {
            "value": "effect-only",
            "label": "Effect ranks only",
            "description": "Use only the purchased Damage ranks.",
            "i18n": {
              "pt-BR": {
                "label": "Apenas ranks do efeito",
                "description": "Usa apenas os ranks comprados de Dano."
              }
            }
          },
          {
            "value": "strength-based",
            "label": "Strength-based",
            "description": "Add the character's effective Strength rank to the purchased Damage ranks.",
            "i18n": {
              "pt-BR": {
                "label": "Baseado em Força",
                "description": "Soma o rank efetivo de Força do personagem aos ranks comprados de Dano."
              }
            }
          }
        ],
        "i18n": {
          "pt-BR": {
            "label": "Base do Dano"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Dano",
        "description": "Inflige dano ao alvo por meio de um ataque corpo a corpo. O alvo resiste com Resistência vs. CD [rank + 15]. Um grau: penalidade de -1 em testes de Resistência futuros. Dois graus: atordoado + penalidade -1. Três graus: cambaleante + penalidade -1. Quatro graus: incapacitado. Penalidades são cumulativas. Alvos incapacitados que falham novamente ficam morrendo, depois mortos. Pode ser baseado em Força para somar ranks de Força ao dano."
      }
    },
    "longDescription": "You inflict damage on a target via a close attack. Target resists with Toughness vs. DC [rank + 15]. One degree: -1 penalty to further Toughness checks. Two degrees: dazed + -1 penalty. Three degrees: staggered + -1 penalty. Four degrees: incapacitated. Penalties are cumulative. Incapacitated targets failing again become dying, then dead. Can be Strength-based to add Strength ranks to damage.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": [
      {
        "id": "attack_check_required",
        "name": "Attack Check Required",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Power Profiles, Counterstrike p. 122: Reaction attack still requires an attack check.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Exige Teste de Ataque",
            "description": "Power Profiles, Contra-ataque p. 122: reação ainda exige teste de ataque."
          }
        }
      }
    ]
  },
  {
    "id": "deflect",
    "name": "Deflect",
    "type": "defense",
    "baseCost": 1,
    "action": "standard",
    "range": "ranged",
    "duration": "instant",
    "description": "You can actively defend others by deflecting or diverting attacks at a distance. Use your Deflect rank in place of an active defense (minimum roll of 11 on 10 or less). -2 at medium range, -5 at long range. Does not work against area effects or perception range attacks, nor attacks targeting defenses other than Dodge or Parry. Limited by power level.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Deflexão",
        "description": "Permite defender ativamente outros personagens defletindo ou desviando ataques à distância. Use seu rank de Deflexão no lugar de uma defesa ativa (mínimo de 11 em rolagens de 10 ou menos). -2 em alcance médio, -5 em alcance longo. Não funciona contra efeitos de área ou ataques de alcance percepção, nem ataques que visem defesas diferentes de Esquiva ou Aparar. Limitado pelo nível de poder."
      }
    },
    "longDescription": "You can actively defend others by deflecting or diverting attacks at a distance. Use your Deflect rank in place of an active defense (minimum roll of 11 on 10 or less). -2 at medium range, -5 at long range. Does not work against area effects or perception range attacks, nor attacks targeting defenses other than Dodge or Parry. Limited by power level.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "reflect",
        "name": "Reflect",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can reflect attacks back at the attacker as a free action. First, you must successfully deflect the attack, then make a normal attack check using your own attack modifier to hit with the reflected attack. It has its normal effect if it hits.",
        "longDescription": "You can reflect attacks back at the attacker as a free action. First, you must successfully deflect the attack, then make a normal attack check using your own attack modifier to hit with the reflected attack. It has its normal effect if it hits.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Refletir",
            "description": "Pode refletir ataques de volta ao atacante como uma ação livre. Primeiro, deve defletir o ataque com sucesso, depois fazer um teste de ataque normal usando seu próprio modificador de ataque para acertar com o ataque refletido. Tem seu efeito normal se acertar."
          }
        }
      },
      {
        "id": "redirect",
        "name": "Redirect",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can redirect attacks you successfully deflect at any target within the attack's normal range, as Reflect. You must have the Reflect extra to take this one.",
        "longDescription": "You can redirect attacks you successfully deflect at any target within the attack's normal range, as Reflect. You must have the Reflect extra to take this one.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Redirecionar",
            "description": "Pode redirecionar ataques que defletir com sucesso para qualquer alvo dentro do alcance normal do ataque, como Refletir. Deve ter o extra Refletir para usar este."
          }
        }
      }
    ],
    "flaws": []
  },
  {
    "id": "elongation",
    "name": "Elongation",
    "type": "general",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can elongate your body and limbs. Add effect rank to your normal size rank to determine elongation distance: 15 feet at rank 1, 30 at rank 2, up to 1,000 miles at rank 20. Can make close attacks at greater distance. Grants +1 bonus to grab checks per rank (limited by PL). Snapping back is a free action.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Alongamento",
        "description": "Permite alongar o corpo e os membros. Some o rank do efeito ao seu rank de tamanho normal para a distância de alongamento: 4,5 m no rank 1, 9 m no rank 2, até 1.600 km no rank 20. Pode fazer ataques corpo a corpo a distâncias maiores. Concede +1 nos testes de agarrar por rank (limitado pelo NP). Voltar ao normal é uma ação livre."
      }
    },
    "longDescription": "You can elongate your body and limbs. Add effect rank to your normal size rank to determine elongation distance: 15 feet at rank 1, 30 at rank 2, up to 1,000 miles at rank 20. Can make close attacks at greater distance. Grants +1 bonus to grab checks per rank (limited by PL). Snapping back is a free action.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": []
  },
  {
    "id": "enhanced-trait",
    "name": "Enhanced Trait",
    "type": "general",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can temporarily improve one of your existing traits by its rank while active. VARIABLE COST: Abilities cost 2 PP/rank, Skills cost 1 PP per 2 ranks (0.5 PP/rank), Advantages and Defenses cost 1 PP/rank. Enhanced Trait is a power effect (not a natural trait) and can be combined with extra effort. Subject to power level limits: unenhanced rank must be below the limit by at least the enhancement amount.",
    "variableCost": {
      "options": [
        {
          "name": "Enhanced Ability",
          "cost": 2
        },
        {
          "name": "Enhanced Skill",
          "cost": 0.5
        },
        {
          "name": "Enhanced Advantage",
          "cost": 1
        },
        {
          "name": "Enhanced Defense",
          "cost": 1
        },
        {
          "name": "Enhanced Extra",
          "cost": 1
        },
        {
          "name": "Enhanced Extra (2 PP)",
          "cost": 2
        },
        {
          "name": "Enhanced Extra (3 PP)",
          "cost": 3
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Traço Aprimorado",
        "description": "Permite melhorar temporariamente um de seus traços existentes pelo valor do rank enquanto ativo. CUSTO VARIÁVEL: Habilidades custam 2 PP/rank, Perícias custam 1 PP por 2 ranks (0,5 PP/rank), Vantagens e Defesas custam 1 PP/rank. Traço Aprimorado é um efeito de poder (não um traço natural) e pode ser combinado com esforço extra. Sujeito aos limites de nível de poder: o rank base deve estar abaixo do limite pelo menos pelo valor do aprimoramento."
      }
    },
    "longDescription": "You can temporarily improve one of your existing traits by its rank while active. VARIABLE COST: Abilities cost 2 PP/rank, Skills cost 1 PP per 2 ranks (0.5 PP/rank), Advantages and Defenses cost 1 PP/rank. Enhanced Trait is a power effect (not a natural trait) and can be combined with extra effort. Subject to power level limits: unenhanced rank must be below the limit by at least the enhancement amount.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": [
      {
        "id": "limited_enhanced_trait_flaw",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Enhanced Trait only works under certain conditions (Nighttime Only, While Angry, Underwater, etc.).",
        "longDescription": "Your Enhanced Trait only works under certain conditions, such as Nighttime (or Daytime) Only, While Angry (or in another emotional state), Underwater (or in some other environment), and so forth. A limit that rarely comes into play—like losing your Enhanced Trait during a new moon—can be handled as a power loss complication.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "permanent_enhanced_trait",
        "name": "Permanent",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Your Enhanced Trait is a permanent improvement. Cannot be turned on/off or improved by extra effort.",
        "longDescription": "At no change in cost, your Enhanced Trait may be a permanent improvement, rather than a sustained effect. The primary difference is that your permanent enhancement cannot be turned on and off and cannot be improved by extra effort, including using it to perform power stunts. There is no action to use a Permanent Enhanced Trait, as it is always active.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "reduced_trait",
        "name": "Reduced Trait",
        "category": "flaw",
        "costType": "flat",
        "costValue": -1,
        "description": "One or more of your traits is lowered while others are enhanced.",
        "longDescription": "One or more of your traits is lowered while others are enhanced. This flaw is worth as many points as the reduction in the affected trait(s). So, for example, if you lose Intellect while you gain in Strength, treat the value of the lost Intellect ranks as the value of the flaw. As with all flaws, the effect must still cost at least 1 power point.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "source_enhanced_trait",
        "name": "Source",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Requires an external source to enhance the trait (Radiation Absorption, Power Profiles p. 150).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Fonte",
            "description": "Exige fonte externa para aprimorar o atributo (Absorção de Radiação, Power Profiles p. 150)."
          }
        }
      }
    ]
  },
  {
    "id": "environment",
    "name": "Environment",
    "type": "control",
    "baseCost": 1,
    "action": "standard",
    "range": "ranged",
    "duration": "sustained",
    "description": "You can change the environment in an area. Affects a 30-foot radius at rank 1, increasing one distance rank per additional rank. VARIABLE COST: 1 PP/rank for distraction or impediment effects. 2 PP/rank if the environment causes damage. Options: Cold (intense/extreme), Heat (intense/extreme), Impede Movement (reduce speed by 1-2 ranks), Light (reduce/eliminate darkness concealment), Visibility (-2 or -5 to Perception). Multiple effects stack or use Selective modifier.",
    "variableCost": {
      "options": [
        {
          "name": "Distraction/Impediment",
          "cost": 1
        },
        {
          "name": "Damaging Environment",
          "cost": 2
        },
        {
          "name": "Visibility (-2)",
          "cost": 1,
          "description": "Visibilidade (-2)"
        },
        {
          "name": "Visibility (-5)",
          "cost": 2,
          "description": "Visibilidade (-5)"
        },
        {
          "name": "Impede Movement (1 rank)",
          "cost": 1,
          "description": "Impedir Movimento (1 graduação)"
        },
        {
          "name": "Impede Movement (2 ranks)",
          "cost": 2,
          "description": "Impedir Movimento (2 graduações)"
        },
        {
          "name": "Cold (1 degree)",
          "cost": 1
        },
        {
          "name": "Cold (2 degrees)",
          "cost": 2
        },
        {
          "name": "Heat (1 degree)",
          "cost": 1
        },
        {
          "name": "Heat (2 degrees)",
          "cost": 2
        },
        {
          "name": "Light",
          "cost": 1
        },
        {
          "name": "Negate Impeded Movement",
          "cost": 1
        },
        {
          "name": "Bright Light",
          "cost": 2
        },
        {
          "name": "Combined Conditions (3 PP)",
          "cost": 3
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Controle Ambiental",
        "description": "Permite alterar o ambiente em uma área. Afeta um raio de 9 m no rank 1, aumentando um rank de distância por rank adicional. CUSTO VARIÁVEL: 1 PP/rank para distração ou impedimento. 2 PP/rank se o ambiente causar dano. Opções: Frio (intenso/extremo), Calor (intenso/extremo), Impedir Movimento (reduz velocidade em 1-2 ranks), Luz (reduz/elimina ocultação por escuridão), Visibilidade (-2 ou -5 em Percepção). Múltiplos efeitos se somam ou usam o modificador Seletivo."
      }
    },
    "longDescription": "You can change the environment in an area. Affects a 30-foot radius at rank 1, increasing one distance rank per additional rank. VARIABLE COST: 1 PP/rank for distraction or impediment effects. 2 PP/rank if the environment causes damage. Options: Cold (intense/extreme), Heat (intense/extreme), Impede Movement (reduce speed by 1-2 ranks), Light (reduce/eliminate darkness concealment), Visibility (-2 or -5 to Perception). Multiple effects stack or use Selective modifier.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "selective",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "With this extra you can vary the environment within your affected area, affecting some while not affecting others, or even mixing and matching different environments (making part of the area cold and another hot, for example).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Com este extra você pode variar o ambiente dentro da área afetada, afetando alguns enquanto não afeta outros, ou até misturando diferentes ambientes (tornando parte da área fria e outra quente, por exemplo)."
          }
        }
      }
    ],
    "flaws": []
  },
  {
    "id": "extra-limbs",
    "name": "Extra Limbs",
    "type": "general",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You have extra manipulative limbs (arms, tentacles, prehensile hair/tail). Each rank grants one extra limb. Provides benefits of Improved Grab (grab with some limbs, leave others free). Does not grant extra actions. Applying all limbs to a grab grants +1 circumstance bonus per rank (max +5). All limbs except dominant are off-hand.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Membros Extras",
        "description": "Você possui membros manipulativos extras (braços, tentáculos, cabelo/cauda preênsil). Cada rank concede um membro extra. Fornece os benefícios de Agarrar Aprimorado (agarrar com alguns membros, deixando outros livres). Não concede ações extras. Usar todos os membros em um agarrar concede +1 de bônus circunstancial por rank (máx. +5). Todos os membros exceto o dominante são mão-inábil."
      }
    },
    "longDescription": "You have extra manipulative limbs (arms, tentacles, prehensile hair/tail). Each rank grants one extra limb. Provides benefits of Improved Grab (grab with some limbs, leave others free). Does not grant extra actions. Applying all limbs to a grab grants +1 circumstance bonus per rank (max +5). All limbs except dominant are off-hand.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "continuous_extra_limbs",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Continuous Extra Limbs are a power effect you can turn on and off at will, but that remain until you choose to deactivate them, even if you are stunned or incapacitated.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Contínuo",
            "description": "Membros Extras Contínuos são um efeito de poder que você pode ativar e desativar à vontade, mas que permanecem até você escolher desativá-los, mesmo se estiver atordoado ou incapacitado."
          }
        }
      },
      {
        "id": "projection_extra_limbs",
        "name": "Projection",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Your Extra Limbs are merely a projection of your power rather than an extension of your body. Therefore, any harm directed specifically against your Extra Limb(s) has no effect. So, for example, one of your additional limbs could reach into a container of acid or a blast furnace to pull out an object without any harm to you.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Projeção",
            "description": "Seus Membros Extras são apenas uma projeção de seu poder em vez de uma extensão de seu corpo. Portanto, qualquer dano direcionado especificamente contra seus Membros Extras não tem efeito."
          }
        }
      },
      {
        "id": "sustained_extra_limbs",
        "name": "Sustained",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Sustained Extra Limbs can be turned on or off (growing or forming the additional limbs and then making them disappear just as easily), but the limbs disappear or stop working if you are unable to continue the effect.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sustentado",
            "description": "Membros Extras Sustentados podem ser ativados ou desativados (crescendo ou formando os membros adicionais e então fazendo-os desaparecer facilmente), mas os membros desaparecem ou param de funcionar se você não puder continuar o efeito."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "distracting_extra_limbs",
        "name": "Distracting",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Using your Extra Limbs is distracting, making you vulnerable.",
        "longDescription": "Using your Extra Limbs is distracting, making you vulnerable (see the Vulnerable condition) while using them.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "feature",
    "name": "Feature",
    "type": "general",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You have one or more minor features granting occasionally useful abilities (one per rank). Similar to the Benefit advantage but derived from powers. Examples: insulating fur, internal compartment, iron stomach, mimicry (+10 to Deception for sounds), quick change, temporal inertia. GM decides what qualifies.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Característica",
        "description": "Você possui uma ou mais características menores que concedem habilidades ocasionalmente úteis (uma por rank). Similar à vantagem Benefício, mas derivada de poderes. Exemplos: pelo isolante, compartimento interno, estômago de ferro, mimetismo (+10 em Enganação para sons), troca rápida, inércia temporal. O Mestre decide o que se qualifica."
      }
    },
    "longDescription": "You have one or more minor features granting occasionally useful abilities (one per rank). Similar to the Benefit advantage but derived from powers. Examples: insulating fur, internal compartment, iron stomach, mimicry (+10 to Deception for sounds), quick change, temporal inertia. GM decides what qualifies.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": []
  },
  {
    "id": "flight",
    "name": "Flight",
    "type": "movement",
    "baseCost": 2,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can fly through the air, including hovering in place. Your flight speed rank equals your effect rank. Common flaws include Gliding (limited by starting height), Levitation (vertical only), Platform (knocked off if you fail a resistance check), and Wings (can't fly if immobilized/restrained/bound).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Voo",
        "description": "Permite voar pelos ares, incluindo pairar no lugar. Sua velocidade de voo é igual ao rank do efeito. Falhas comuns incluem Planar (limitado pela altura inicial), Levitação (apenas vertical), Plataforma (derrubado se falhar resistência), e Asas (não pode voar se imobilizado/contido/amarrado)."
      }
    },
    "longDescription": "Flight allows the character to move through the air at a speed rank equal to its rank. Rank 0 = hovering only. Rank 1 = 2 mph, Rank 5 = 30 mph, Rank 10 = 1000 mph (supersonic), Rank 15 = orbital velocity, Rank 20 = FTL. Unlike movement powers, Flight allows full 3D movement. Using Flight in combat uses the move action.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "aquatic",
        "name": "Aquatic",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "You can move underwater as easily as in the air. Water speed = Flight rank - 2.",
        "longDescription": "You can move underwater as easily as in the air. You have a water speed equal to your Flight rank, minus 2, subject to the usual rules for swimming. You can make Athletics checks to swim as routine checks. This power does not allow you to breathe underwater (for that see Immunity). This is the Swimming power as an Alternate Effect.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "continuous_flight",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Flight operates even when incapacitated. You remain hanging in the air or float safely down.",
        "longDescription": "Continuous Flight operates even when the user is incapacitated or otherwise unable to sustain it. The user remains hanging in the air, maintaining relative position to the ground, if necessary. Alternately, the user might float safely down to the ground when unable to maintain Flight as a kind of \"safety net,\" your choice when you apply the modifier.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "subtle_flight",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Reduces or eliminates flight traces (rush of air, jet roar, contrail). Completely Subtle = automatic silent movement.",
        "longDescription": "The default Flight effect is noticeable, whether from the rush of air, the roar of jets, or a glowing contrail or aurora. This modifier reduces, and then eliminates, these traces. If your Flight is completely Subtle, you do not need to make Stealth checks to move silently while flying (you do so automatically), although you may still need to do so to avoid being seen or otherwise detected.",
        "incompatibleWith": [],
        "maxRanks": 2,
        "i18n": {}
      }
    ],
    "flaws": [
      {
        "id": "gliding",
        "name": "Gliding",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only glide, not truly fly. You lose altitude each round unless soaring on a draft.",
        "longDescription": "With Gliding, you can move horizontally but must lose altitude each round. In updrafts you may maintain altitude. You cannot hover or fly upward without a strong wind.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Planador",
            "description": "Você só pode planar, não voar de verdade. Perde altitude por rodada.",
            "longDescription": "Com Planador, você se move horizontalmente mas deve perder altitude por rodada. Não pode pairar ou subir sem vento."
          }
        }
      },
      {
        "id": "levitation",
        "name": "Levitation",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only fly straight up or down, not move horizontally while airborne.",
        "longDescription": "Levitation allows vertical movement only. You can rise and hover, but cannot move horizontally under your own power while in the air.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Levitação",
            "description": "Você pode apenas voar para cima ou baixo, sem movimento horizontal no ar.",
            "longDescription": "Levitação permite apenas movimento vertical. Você pode subir e pairar, mas não se mover horizontalmente."
          }
        }
      },
      {
        "id": "wings",
        "name": "Wings",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Flight requires functional wings. They take up your off-hand slot and can be damaged.",
        "longDescription": "Your flight requires wings. If the wings are grabbed, damaged, or you are in a space too small for them, you cannot fly. Wings are noticeable and take up the equivalent of an extra limb.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Asas",
            "description": "O voo exige asas funcionais. Elas podem ser agarradas ou danificadas.",
            "longDescription": "Seu voo exige asas. Se as asas forem agarradas, danificadas ou você estiver num espaço pequeno, não pode voar."
          }
        }
      },
      {
        "id": "concentration_flight",
        "name": "Concentration",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can fly, but can't do much else at the same time.",
        "longDescription": "Flight requiring concentration means you can fly, but can't do much else at the same time. You must maintain concentration to keep flying.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "distracting_flight",
        "name": "Distracting",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You are not very maneuverable and therefore vulnerable while flying.",
        "longDescription": "You are not very maneuverable and therefore vulnerable while flying (see the Vulnerable condition). This represents poor control or difficulty maintaining flight.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "platform",
        "name": "Platform",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Flight relies on a platform. If knocked off or grabbed from ground, you cannot fly until reactivated.",
        "longDescription": "Your Flight is reliant on some sort of platform on which you stand or sit. If you fail a resistance check while flying, or you are grabbed by someone standing on the ground, you're knocked or pulled off your platform and cannot fly. You can regain the use of your flying platform by reactivating your Flight effect on your next turn.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "growth",
    "name": "Growth",
    "type": "general",
    "baseCost": 2,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can temporarily increase your size. Each rank adds +1 Strength and +1 Stamina, +1 mass rank. Every 2 ranks: +1 Intimidation. Every 8 ranks: +1 Speed. Each rank: -1 Stealth. Every 2 ranks: -1 Dodge and Parry. Every 4 ranks: +1 size rank. Growth modifiers are restricted by power level limits.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Crescimento",
        "description": "Permite aumentar temporariamente seu tamanho. Cada rank adiciona +1 Força e +1 Vigor, +1 rank de massa. A cada 2 ranks: +1 Intimidação. A cada 8 ranks: +1 Velocidade. Cada rank: -1 Furtividade. A cada 2 ranks: -1 Esquiva e Aparar. A cada 4 ranks: +1 rank de tamanho. Modificadores de Crescimento são restritos pelos limites de nível de poder."
      }
    },
    "longDescription": "You can temporarily increase your size. Each rank adds +1 Strength and +1 Stamina, +1 mass rank. Every 2 ranks: +1 Intimidation. Every 8 ranks: +1 Speed. Each rank: -1 Stealth. Every 2 ranks: -1 Dodge and Parry. Every 4 ranks: +1 size rank. Growth modifiers are restricted by power level limits.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "permanent_growth",
        "name": "Permanent",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Your Growth is permanent. You are always at your increased size.",
        "longDescription": "Your Growth is permanent. You are always at your increased size and cannot return to normal size, although the effect can still be Nullified unless it is also Innate.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ],
    "flaws": []
  },
  {
    "id": "healing",
    "name": "Healing",
    "type": "general",
    "baseCost": 2,
    "action": "standard",
    "range": "close",
    "duration": "instant",
    "description": "You can heal Damage conditions by touch with a DC 10 Healing check. Each degree of success heals one condition, starting from worst. If the subject is dying, highest degree stabilizes them. Failed check: must wait 1 minute or use extra effort. Also grants bonus equal to rank on resistance checks vs. disease/poison. Does not work on subjects without Stamina.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Cura",
        "description": "Permite curar condições de Dano por toque com um teste de Cura CD 10. Cada grau de sucesso cura uma condição, começando pela pior. Se o alvo estiver morrendo, o grau mais alto o estabiliza. Teste falho: deve esperar 1 minuto ou usar esforço extra. Também concede bônus igual ao rank em testes de resistência contra doenças/venenos. Não funciona em alvos sem Vigor."
      }
    },
    "longDescription": "Healing restores lost damage and removes conditions. Each rank allows healing one damage condition (bruised, hurt, injured, wounded, staggered, incapacitated) or one non-lethal condition removed. Healing requires touch and a standard action. You can also restore incapacitated targets or remove lasting conditions. Healing does not work on yourself unless combined with Affects Others or a separate self-healing power.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "persistent",
        "name": "Persistent",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Healing removes Incurable damage. Legacy +1 PP per effect rank, preserved for existing characters; use Persistent (flat purchase) for the official flat +1 PP cost.",
        "longDescription": "Healing removes Incurable damage. Legacy +1 PP per effect rank, preserved for existing characters; use Persistent (flat purchase) for the official flat +1 PP cost.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Persistente",
            "description": "Cura remove dano Incurável. Preço legado de +1 PP por graduação do efeito preservado para personagens existentes; use Persistente (compra fixa) para o custo oficial de +1 PP fixo.",
            "longDescription": "Cura remove dano Incurável. Preço legado de +1 PP por graduação do efeito preservado para personagens existentes; use Persistente (compra fixa) para o custo oficial de +1 PP fixo."
          }
        }
      },
      {
        "id": "restorative",
        "name": "Restorative",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Can heal ability damage and restore lost abilities.",
        "longDescription": "Restorative Healing can undo ability damage and restore abilities lost or nullified by powers, removing conditions like Weakened on trait scores.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Restaurativo",
            "description": "Pode curar dano de atributo e restaurar atributos perdidos.",
            "longDescription": "Cura Restaurativa pode desfazer dano de atributo e restaurar atributos perdidos ou anulados por poderes."
          }
        }
      },
      {
        "id": "stabilize",
        "name": "Stabilize",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Can automatically stabilize a dying character without a skill check.",
        "longDescription": "With Stabilize, you can automatically prevent a dying character from slipping further toward death without requiring a Treatment check, though this still requires the normal healing action.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Estabilizar",
            "description": "Pode estabilizar automaticamente um personagem morrendo sem teste de perícia.",
            "longDescription": "Com Estabilizar, você pode automaticamente evitar que um personagem morra sem exigir teste de Tratamento."
          }
        }
      },
      {
        "id": "action_healing",
        "name": "Action",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Reduces the action required to use Healing. Cannot use more than once per turn.",
        "longDescription": "This extra reduces the action required for you to use Healing. You cannot use Healing more than once per turn regardless. To heal multiple subjects at once, apply the Area modifier.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "affects_objects_healing",
        "name": "Affects Objects",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Your Healing can also \"heal\" damage to non-living subjects.",
        "longDescription": "Your Healing can also \"heal\" damage to non-living subjects. You make a Healing check against the subject's worst damage condition, as normal.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "area_healing",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Healing grants the same benefit to all subjects in the affected area.",
        "longDescription": "Healing with this extra grants the same benefit to all subjects in the affected area. Area Empathic Healing is an unwise combination, as the healer takes on all of the damage conditions of the affected subjects at once!",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "energizing",
        "name": "Energizing",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Can heal fatigued and exhausted conditions. DC 10: one degree for fatigued, two for exhausted. You take on the removed conditions.",
        "longDescription": "You can heal the fatigued and exhausted conditions as well as damage conditions: DC 10, one degree of success for fatigued, two degrees of success for exhausted. However, you take on the removed conditions and cannot use Healing to eliminate your own fatigue (although you can still use hero points to recover from them). If the Healing check fails, you must wait the normal recovery time or use extra effort to try again.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "perception_healing",
        "name": "Perception",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Applied to Ranged Healing, does not require an attack check to \"touch\" the subject.",
        "longDescription": "Applied to Ranged Healing, Perception Ranged Healing does not require an attack check to \"touch\" the subject. You must still be able to perceive the target.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "ranged_healing",
        "name": "Ranged",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Ranged Healing requires an attack check to \"touch\" the subject.",
        "longDescription": "Ranged Healing requires an attack check to \"touch\" the subject with the Healing effect. The GM may waive the check for a willing subject holding completely still, but the subject is defenseless that round, making it an unwise decision in the midst of combat.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "resurrection",
        "name": "Resurrection",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Can restore life to the dead! DC 20 check if dead for fewer minutes than your rank.",
        "longDescription": "You can restore life to the dead! If the subject has been dead for fewer minutes than your Healing rank, make a DC 20 Healing check. If successful, the patient's condition becomes incapacitated, as if just stabilized. If the check fails, you can only try again using extra effort.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "selective_healing",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Area Healing may have this extra, allowing you to choose who in the area does and does not gain the benefits.",
        "longDescription": "Area Healing may have this extra, allowing you to choose who in the area does and does not gain the benefits.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "bonus_effect_healing",
        "name": "Bonus Effect",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Electrical Absorption, Power Profiles p. 59. Can counter extra effort fatigue.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Efeito Adicional",
            "description": "Absorção Elétrica, Power Profiles p. 59. Pode remover fadiga por esforço extra."
          }
        }
      },
      {
        "id": "persistent_flat",
        "name": "Persistent (flat purchase)",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Heals Incurable damage. Flat +1 PP, Deluxe Hero’s Handbook p. 167. Existing per-rank records are preserved.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Persistente (compra fixa)",
            "description": "Cura dano Incurável. +1 PP fixo, Deluxe Hero’s Handbook p. 167. Registros antigos por graduação são preservados."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "empathic",
        "name": "Empathic",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "When you cure someone else of a condition, you acquire the condition yourself.",
        "longDescription": "When you successfully cure someone else of a condition, you acquire the condition yourself and must recover from it normally. You can use Healing and Regeneration to cure your own conditions. You can have the Resurrection modifier for Healing, but if you successfully use it, you die! This may not be as bad as it seems if you have Immortality, allowing you to return to life.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "limited_healing",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Healing is limited in some way (One Type of Damage, Objects only, Others only, Self only).",
        "longDescription": "Examples of ways in which Healing may be Limited include: One Type of Damage (such as energy or bludgeoning damage), Objects (in conjunction with Affects Objects), Others (you can't use Healing on yourself), or Self (you can only use Healing on yourself).",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "temporary_healing",
        "name": "Temporary",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Benefits last one hour. Subject then regains any damage conditions you healed.",
        "longDescription": "The benefits of your Healing are temporary, lasting for one hour. The subject then regains any damage conditions you healed. These conditions stack with others the subject acquired since the initial healing, which may result in more severe damage or even death.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "source_healing",
        "name": "Source",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Electrical Absorption, Power Profiles p. 59. Only with an external source.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Fonte",
            "description": "Absorção Elétrica, Power Profiles p. 59. Somente com fonte externa."
          }
        }
      }
    ]
  },
  {
    "id": "illusion",
    "name": "Illusion",
    "type": "control",
    "baseCost": 1,
    "action": "standard",
    "range": "perception",
    "duration": "sustained",
    "description": "You can create false sensory impressions. Cost varies: 1 pt/rank for one sense type, 2 for two, 3 for three, 4 for four, 5 for all (visual counts as two). Your rank determines DC for Insight resistance check (DC 10 + rank). Illusion volume rank equals effect rank. Illusions have no substance. Maintaining an active illusion is a standard action; static is a free action.",
    "variableCost": {
      "options": [
        {
          "name": "One sense type",
          "cost": 1
        },
        {
          "name": "Two sense types",
          "cost": 2
        },
        {
          "name": "Three sense types",
          "cost": 3
        },
        {
          "name": "Four sense types",
          "cost": 4
        },
        {
          "name": "All sense types",
          "cost": 5
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Ilusão",
        "description": "Permite criar falsas impressões sensoriais. Custo varia: 1 pp/rank para um tipo de sentido, 2 para dois, 3 para três, 4 para quatro, 5 para todos (visual conta como dois). Seu rank determina a CD do teste de resistência de Intuição (CD 10 + rank). Volume da ilusão igual ao rank do efeito. Ilusões não têm substância. Manter uma ilusão ativa é ação padrão; estática é ação livre."
      }
    },
    "longDescription": "Illusion creates sensory phenomena that are not real. Each rank covers one sense. You choose which senses at acquisition. The observer suspects the illusion and makes a Will check (DC 10 + rank). Success means they recognize it as fake; failure means they believe it. Illusions have no substance—physical interaction reveals them unless Believable is applied. Visual illusions (sight) cost double ranks.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "independent_illusion",
        "name": "Independent",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Active illusions only require a free action to maintain, rather than a standard action.",
        "longDescription": "Your active illusions only require a free action to maintain, rather than a standard action. This allows you to maintain complex, moving illusions while still taking other actions.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "selective_illusion",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You choose who perceives your Illusion and who doesn't.",
        "longDescription": "You choose who perceives your Illusion and who doesn't. This allows you to create illusions visible only to specific targets.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ],
    "flaws": [
      {
        "id": "feedback_illusion",
        "name": "Feedback",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "A successful damaging attack on one of your illusions causes you to suffer damage.",
        "longDescription": "Although Illusion does not have a physical \"manifestation\" per se, it can apply this flaw, in which case a successful damaging attack on one of your illusions causes you to suffer damage, using the guidelines given in the description of the Feedback flaw.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "limited_one_subject",
        "name": "Limited to One Subject",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Only a single subject at a time can perceive your Illusion.",
        "longDescription": "Only a single subject at a time can perceive your Illusion. This significantly limits the utility of the power.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "ranged_illusion",
        "name": "Ranged",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Illusion's range is reduced. Being able to perceive the affected area is important.",
        "longDescription": "It is left to the GM's discretion whether or not Illusion's range can be reduced at all, since being able to perceive the affected area is important in creating and directing the illusion. In order to solely alter your own appearance, see the Morph effect, possibly with the Resistible modifier.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "resistible_illusion",
        "name": "Resistible",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Illusions Resistible by Will (hallucinatory) or Fortitude (biochemical). Targets immune to the resistance are unaffected.",
        "longDescription": "Illusions Resistible by Will are typically hallucinatory effects projected into the target's mind. This flaw is commonly combined with Selective, so only the targets you choose perceive your illusions. Illusions Resistible by Fortitude may represent a hallucinatory drug or similar biochemical effect. As usual, targets immune to effects targeting the resistance are unaffected by the illusion as well. This resistance check is in addition to the usual Insight check.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "immortality",
    "name": "Immortality",
    "type": "defense",
    "baseCost": 2,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You can recover from death. Subtract your Immortality rank from time rank 19 (one month) to determine recovery time. So rank 11 = 30 minutes, rank 20 = start of each action round. When you recover, all damage conditions are removed, but you lose all accumulated hero points.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Imortalidade",
        "description": "Permite se recuperar da morte. Subtraia seu rank de Imortalidade do rank de tempo 19 (um mês) para determinar o tempo de recuperação. Rank 11 = 30 minutos, rank 20 = início de cada rodada de ação. Ao se recuperar, todas as condições de dano são removidas, mas você perde todos os pontos de herói acumulados."
      }
    },
    "longDescription": "You can recover from death. Subtract your Immortality rank from time rank 19 (one month) to determine recovery time. So rank 11 = 30 minutes, rank 20 = start of each action round. When you recover, all damage conditions are removed, but you lose all accumulated hero points.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": [
      {
        "id": "limited_immortality",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You must specify a reasonably common effect (or set of uncommon effects) that keeps you from recovering from death, such as beheading, cremation, a stake through the heart, and so forth. Even then, if the effect is somehow removed or reversed (e.g., the stake is removed from your corpse) you may still be able to come back.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "Você deve especificar um efeito razoavelmente comum (ou conjunto de efeitos incomuns) que impede você de se recuperar da morte, como decapitação, cremação, uma estaca no coração, etc. Mesmo assim, se o efeito for removido ou revertido, você ainda pode voltar."
          }
        }
      }
    ]
  },
  {
    "id": "immunity",
    "name": "Immunity",
    "type": "defense",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You are immune to certain effects, automatically succeeding on resistance checks. Assign ranks to effects: 1 rank (aging, disease, poison, one environment, etc.), 2 ranks (critical hits, suffocation), 5 ranks (alteration, sensory Affliction, a Damage descriptor), 10 ranks (common descriptor, life support), 20 ranks (very common descriptor), 30 ranks (all Fortitude/Will effects), 80 ranks (all Toughness effects).",
    "variableCost": {
      "costType": "flat",
      "options": [
        {
          "name": "Aging / Disease / Poison / One environment",
          "cost": 1
        },
        {
          "name": "Critical hits / Suffocation (all)",
          "cost": 2
        },
        {
          "name": "Alteration / Sensory Affliction / One Damage descriptor",
          "cost": 5
        },
        {
          "name": "Common descriptor / Life support",
          "cost": 10
        },
        {
          "name": "Very common descriptor (bludgeoning, energy)",
          "cost": 20
        },
        {
          "name": "All effects resisted by Fortitude or Will",
          "cost": 30
        },
        {
          "name": "All effects resisted by Toughness",
          "cost": 80
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Imunidade",
        "description": "Torna-se imune a certos efeitos, tendo sucesso automático em testes de resistência. Atribua ranks: 1 rank (envelhecimento, doença, veneno, um ambiente, etc.), 2 ranks (acertos críticos, sufocação), 5 ranks (alteração, Aflição sensorial, um descritor de Dano), 10 ranks (descritor comum, suporte vital), 20 ranks (descritor muito comum), 30 ranks (todos os efeitos de Fortitude/Vontade), 80 ranks (todos os efeitos de Resistência)."
      }
    },
    "longDescription": "Immunity provides complete protection against a specific hazard or effect. The cost is 1 rank per hazard if the immunity is broad: Immunity 1 = one specific effect; Immunity 5 = a category; Immunity 10 = all effects of a broad type; Immunity 80 = all environmental hazards. Common examples: Immunity 1 (disease), Immunity 10 (fire effects), Immunity 30 (Fortitude effects).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "affects_others",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "This extra allows you to grant the benefits of your Immunity to others by touch. It's most commonly used with life support, such as the power to maintain a life support 'bubble' around you.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Outros",
            "description": "Este extra permite conceder os benefícios da sua Imunidade a outros por toque. É mais comumente usado com suporte vital, como o poder de manter uma 'bolha' de suporte vital ao seu redor."
          }
        }
      },
      {
        "id": "sustained_immunity",
        "name": "Sustained",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Sustained duration Immunity may be suitable for certain types of powers, particularly force fields or similar protective abilities requiring a modicum of concentration. It is a net +0 modifier from Immunity's base permanent duration.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sustentado",
            "description": "Imunidade de duração Sustentada pode ser adequada para certos tipos de poderes, particularmente campos de força ou habilidades protetoras similares que requerem um mínimo de concentração. É um modificador +0 da duração permanente base da Imunidade."
          }
        }
      },
      {
        "id": "ranged_immunity",
        "name": "Ranged",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Affects Others Immunity may have this extra, allowing it to grant its benefits at range.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "À Distância",
            "description": "Imunidade Afeta Outros pode ter este extra, permitindo conceder seus benefícios à distância."
          }
        }
      },
      {
        "id": "reflect_immunity",
        "name": "Reflect",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can reflect attacks to which you are immune back at the attacker as a free action. Make a normal attack check using your own attack modifier to hit with the reflected attack. It has its normal effect if it hits.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Refletir",
            "description": "Pode refletir ataques aos quais é imune de volta ao atacante como uma ação livre. Faça um teste de ataque normal usando seu próprio modificador de ataque para acertar com o ataque refletido. Tem seu efeito normal se acertar."
          }
        }
      },
      {
        "id": "redirect_immunity",
        "name": "Redirect",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can redirect attacks to which are you are immune at any other target within the attack's normal range, as Reflect, above. You must have the Reflect extra to take this one.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Redirecionar",
            "description": "Pode redirecionar ataques aos quais é imune para qualquer outro alvo dentro do alcance normal do ataque, como Refletir. Deve ter o extra Refletir para usar este."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "half_effect",
        "name": "Half Effect",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Immunity provides only half protection (resistance rather than immunity).",
        "longDescription": "With Half Effect, the Immunity only reduces the effect rather than granting complete protection. For damage, this means -half the rank in Toughness bonus; for conditions, a +5 bonus to resistance checks.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Metade do Efeito",
            "description": "A Imunidade fornece apenas metade da proteção (resistência em vez de imunidade).",
            "longDescription": "Com Metade do Efeito, a Imunidade apenas reduz o efeito. Para dano, bônus de Resistência = metade do rank; para condições, +5 nos testes de resistência."
          }
        }
      }
    ]
  },
  {
    "id": "impervious-resistance",
    "name": "Impervious Resistance",
    "type": "defense",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "Applies Impervious ranks to an existing resistance, usually Toughness. This utility effect costs 1 PP/rank and does not increase the selected resistance or grant Protection.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "resistance",
        "label": "Resistance",
        "control": "dropdown",
        "required": true,
        "options": [
          {
            "value": "toughness",
            "label": "Toughness",
            "description": "The usual resistance for Impervious, including Toughness provided by Stamina.",
            "i18n": {
              "pt-BR": {
                "label": "Resistência",
                "description": "A resistência usual para Impenetrável, incluindo Resistência concedida por Vigor."
              }
            }
          },
          {
            "value": "fortitude",
            "label": "Fortitude",
            "description": "Requires GM approval when Impervious applies to this resistance.",
            "i18n": {
              "pt-BR": {
                "label": "Fortitude",
                "description": "Requer aprovação do mestre quando Impenetrável se aplica a esta resistência."
              }
            }
          },
          {
            "value": "will",
            "label": "Will",
            "description": "Requires GM approval when Impervious applies to this resistance.",
            "i18n": {
              "pt-BR": {
                "label": "Vontade",
                "description": "Requer aprovação do mestre quando Impenetrável se aplica a esta resistência."
              }
            }
          },
          {
            "value": "dodge",
            "label": "Dodge",
            "description": "Requires GM approval when Impervious applies to this defense.",
            "i18n": {
              "pt-BR": {
                "label": "Esquiva",
                "description": "Requer aprovação do mestre quando Impenetrável se aplica a esta defesa."
              }
            }
          },
          {
            "value": "parry",
            "label": "Parry",
            "description": "Requires GM approval when Impervious applies to this defense.",
            "i18n": {
              "pt-BR": {
                "label": "Aparar",
                "description": "Requer aprovação do mestre quando Impenetrável se aplica a esta defesa."
              }
            }
          }
        ],
        "i18n": {
          "pt-BR": {
            "label": "Resistência"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Resistência Impenetrável",
        "description": "Aplica ranks de Impenetrável a uma resistência existente, normalmente Resistência. Este efeito utilitário custa 1 PP/rank e não aumenta a resistência selecionada nem concede Proteção."
      }
    },
    "longDescription": "Impervious is normally purchased as an extra on a resistance. This utility effect represents Impervious bought directly for an existing resistance, such as Toughness from Stamina, where there is no separate Protection effect to carry the modifier. Each rank costs 1 PP. It records the Impervious threshold only and never increases the underlying resistance.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": []
  },
  {
    "id": "insubstantial",
    "name": "Insubstantial",
    "type": "general",
    "baseCost": 5,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can assume a less solid form. Rank 1 (Fluid): flow through any non-watertight opening, exert normal Strength. Rank 2 (Gaseous): no Strength, immune to physical Damage, flow through non-airtight openings. Rank 3 (Energy): no Strength, immune to physical Damage, pass through energy-permeable objects. Rank 4 (Incorporeal): pass through solid matter, immune to physical and energy Damage.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Insubstancial",
        "description": "Permite assumir uma forma menos sólida. Rank 1 (Fluido): flui por aberturas não estanques, exerce Força normal. Rank 2 (Gasoso): sem Força, imune a Dano físico, flui por aberturas não herméticas. Rank 3 (Energia): sem Força, imune a Dano físico, atravessa objetos permeáveis a energia. Rank 4 (Incorpóreo): atravessa matéria sólida, imune a Dano físico e energético."
      }
    },
    "longDescription": "You can assume a less solid form. Rank 1 (Fluid): flow through any non-watertight opening, exert normal Strength. Rank 2 (Gaseous): no Strength, immune to physical Damage, flow through non-airtight openings. Rank 3 (Energy): no Strength, immune to physical Damage, pass through energy-permeable objects. Rank 4 (Incorporeal): pass through solid matter, immune to physical and energy Damage.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "affects_corporeal",
        "name": "Affects Corporeal",
        "category": "extra",
        "costType": "flat_ranked",
        "costValue": 1,
        "description": "Required for any effect that works on corporeal targets while you are incorporeal.",
        "longDescription": "This extra is required for any effect that works on corporeal targets while you are incorporeal. See the Affects Corporeal extra description for details and cost.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "affects_others_insubstantial",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Allows you to extend your Insubstantial effect to another character by touch.",
        "longDescription": "This modifier allows you to extend your Insubstantial effect to another character by touch, taking them Insubstantial with you. If you ever withdraw the effect while someone is inside a solid object, see the effect's description for the unpleasant results.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "attack_insubstantial",
        "name": "Attack",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Makes Insubstantial into a close range effect able to turn targets Insubstantial.",
        "longDescription": "Applied to Insubstantial, this extra makes it into a close range effect able to turn targets Insubstantial. You must be able to physically touch the target to make an Insubstantial Attack, meaning it must have the Affects Corporeal modifier to use it while you are incorporeal. This modifier is most effective for ranks 2 through 4, since the victim loses some or all ability to interact with the physical world. The default resistance for an Insubstantial Attack is Dodge, although it can be Fortitude or Will, as best suits the effect's descriptors.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "continuous_insubstantial",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Allows you to remain Insubstantial until you choose to return to corporeal form.",
        "longDescription": "Extending the effect's duration to continuous allows you to remain Insubstantial until you choose to return to your corporeal form.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "innate_insubstantial",
        "name": "Innate",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Your character's form is naturally or innately Insubstantial, particularly if the effect is permanent.",
        "longDescription": "Use this modifier if your character's form is naturally or innately Insubstantial, particularly if the effect is permanent in duration.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "precise_insubstantial",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Allows you to selectively make some portions of your body insubstantial while keeping others substantial.",
        "longDescription": "This modifier allows you to selectively make some portions of your body insubstantial while keeping others substantial (or vice versa). This allows you to do things like reach through a wall, solidify your hand to pick up an object or tap someone on the shoulder (or punch them in the face), and become incorporeal again to withdraw it on the following round.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "progressive_insubstantial",
        "name": "Progressive",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "You can assume lower ranked forms of Insubstantial, but must progress through them in order.",
        "longDescription": "You can assume lower ranked forms of Insubstantial, but you must progress through them in order to reach the higher-ranked ones. For example if you have Progressive Insubstantial 3, you can assume fluid, gaseous, or energy forms, but to assume energy form, you must first progress through fluid and gaseous, becoming less and less substantial. Since you can only activate the effect once per turn, it takes you three turns to get there.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "reaction_insubstantial",
        "name": "Reaction",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Allows you to switch forms \"reflexively\" in response to hazards, even if it is not your turn.",
        "longDescription": "Becoming Insubstantial is normally a free action, meaning you can't switch to an Insubstantial form when surprised or otherwise unable to take action. At the GM's option, applying the Action extra to use Insubstantial as a reaction allows you to switch forms \"reflexively\" in response to such hazards, even if it is not your turn.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "subtle_insubstantial",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Makes your Insubstantial nature less noticeable to observers.",
        "longDescription": "This extra makes your Insubstantial nature less noticeable to observers. Rank 1 requires a Perception check (DC 20) to detect that you are Insubstantial, while 2 ranks mean you look entirely normal in Insubstantial form (which may cause opponents to waste effort on you, not knowing you are immune to their attacks, for example).",
        "incompatibleWith": [],
        "maxRanks": 2,
        "i18n": {}
      }
    ],
    "flaws": [
      {
        "id": "absent_strength",
        "name": "Absent Strength",
        "category": "flaw",
        "costType": "flat",
        "costValue": -1,
        "description": "Applies only to rank 1 Insubstantial. Removes your effective Strength while in that form.",
        "longDescription": "This flaw applies only to rank 1 Insubstantial and removes your effective Strength while in that form, leaving you with limited ability to affect the physical world like the higher ranks of the effect.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "permanent_insubstantial",
        "name": "Permanent",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": 0,
        "description": "You are always Insubstantial; you cannot assume solid form.",
        "longDescription": "You are always Insubstantial; you cannot assume solid form, although your Insubstantial effect can still be Nullified unless it is also Innate.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "leaping",
    "name": "Leaping",
    "type": "movement",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "instant",
    "description": "You can make prodigious leaps. Your Leaping rank minus 2 is the distance rank covered in a single standing jump: 15 feet at rank 1, 30 at rank 2, up to 1,000 miles at rank 20. You suffer no damage from landing within your maximum distance. Leap speed maxes out at rank 7 (~250 mph).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Salto",
        "description": "Permite dar saltos prodigiosos. Seu rank de Salto menos 2 é o rank de distância coberta em um salto parado: 4,5 m no rank 1, 9 m no rank 2, até 1.600 km no rank 20. Não sofre dano ao aterrissar dentro da distância máxima. A velocidade do salto tem máximo no rank 7 (~400 km/h)."
      }
    },
    "longDescription": "You can make prodigious leaps. Your Leaping rank minus 2 is the distance rank covered in a single standing jump: 15 feet at rank 1, 30 at rank 2, up to 1,000 miles at rank 20. You suffer no damage from landing within your maximum distance. Leap speed maxes out at rank 7 (~250 mph).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "affects_others_leaping",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "You can give someone you are touching the ability to leap like you do while the effect lasts. You do not need this extra to simply carry someone while you leap; you can carry what your Strength normally allows.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Outros",
            "description": "Você pode dar a alguém que está tocando a habilidade de saltar como você enquanto o efeito durar. Você não precisa deste extra para simplesmente carregar alguém enquanto salta."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "acrobatics_check_required",
        "name": "Acrobatics Check Required",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "In order to use Leaping, you must make an Acrobatics skill check (DC 10). Each point your check total exceeds the DC allows you to use 1 rank of Leaping, up to your total rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Teste de Acrobacia Necessário",
            "description": "Para usar Salto, você deve fazer um teste de Acrobacia (CD 10). Cada ponto que seu total exceder a CD permite usar 1 rank de Salto, até seu rank total."
          }
        }
      },
      {
        "id": "full_power_leaping",
        "name": "Full Power",
        "category": "flaw",
        "costType": "flat",
        "costValue": -1,
        "description": "You can only leap your maximum distance; you can make shorter leaps only by not using your Leaping effect at all, just the normal jumping distance for your Strength. This may suit uncontrollable 'leaping' effects like rocket boosters and the like.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Poder Total",
            "description": "Você só pode saltar sua distância máxima; você pode fazer saltos menores apenas não usando seu efeito de Salto, apenas a distância normal de salto para sua Força."
          }
        }
      }
    ]
  },
  {
    "id": "luck-control",
    "name": "Luck Control",
    "type": "control",
    "baseCost": 3,
    "action": "reaction",
    "range": "perception",
    "duration": "instant",
    "description": "You can use hero points or Luck to affect others. Each rank provides one option: spend a hero point on another's behalf, bestow hero points to others, negate someone else's hero point/Luck/complication use, or force a re-roll taking the worse result. Target may spend a hero point to avoid the re-roll.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Controle da Sorte",
        "description": "Permite usar pontos de herói ou Sorte para afetar outros. Cada rank fornece uma opção: gastar um ponto de herói em benefício de outro, conceder pontos de herói a outros, negar o uso de ponto de herói/Sorte/complicação de alguém, ou forçar uma nova rolagem ficando com o pior resultado. O alvo pode gastar um ponto de herói para evitar a nova rolagem."
      }
    },
    "longDescription": "You can use hero points or Luck to affect others. Each rank provides one option: spend a hero point on another's behalf, bestow hero points to others, negate someone else's hero point/Luck/complication use, or force a re-roll taking the worse result. Target may spend a hero point to avoid the re-roll.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "area_luck",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Your Luck Control effect works equally on all targets in the affected area. You spend only one hero point, but the subjects are each affected individually. You must apply the same effect to all subjects at once.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Área",
            "description": "Seu efeito de Controle da Sorte funciona igualmente em todos os alvos na área afetada. Você gasta apenas um ponto de herói, mas os alvos são afetados individualmente. Deve aplicar o mesmo efeito a todos os alvos de uma vez."
          }
        }
      },
      {
        "id": "luck_advantage",
        "name": "Luck",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Each rank in this extra gives you the benefit of a rank in the Luck advantage. It is subject to the same limits as the Luck advantage set by the GM.",
        "longDescription": "Each rank in this extra gives you the benefit of a rank in the Luck advantage. It is subject to the same limits as the Luck advantage set by the GM. Flat +1 point per rank of Luck.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sorte",
            "description": "Cada rank neste extra concede o benefício de um rank na vantagem Sorte. Está sujeito aos mesmos limites da vantagem Sorte definidos pelo Mestre."
          }
        }
      },
      {
        "id": "selective_luck",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "This extra, applied to Area Luck Control, allows you to choose who in the area is or is not affected by it.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Este extra, aplicado a Controle da Sorte em Área, permite escolher quem na área é ou não afetado por ele."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "action_luck",
        "name": "Action",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "If the action required for Luck Control is increased beyond a reaction, it is only usable during your turn each round, which limits its usefulness in responding to the actions of others.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Ação",
            "description": "Se a ação necessária para Controle da Sorte for aumentada além de uma reação, só é utilizável durante seu turno a cada rodada, o que limita sua utilidade em responder às ações de outros."
          }
        }
      },
      {
        "id": "ranged_luck",
        "name": "Ranged",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Luck Control normally requires no attack check; if Ranged, it does.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "À Distância",
            "description": "Controle da Sorte normalmente não requer teste de ataque; se À Distância, requer."
          }
        }
      },
      {
        "id": "resistible",
        "name": "Resistible",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Targets of your Luck Control get a resistance check—usually Dodge or Will—to avoid its effects.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Resistível",
            "description": "Alvos do seu Controle da Sorte fazem um teste de resistência—geralmente Esquiva ou Vontade—para evitar seus efeitos."
          }
        }
      },
      {
        "id": "side_effect_luck",
        "name": "Side Effect",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "As a particular side effect of Luck Control, if your effort to alter luck fails, you suffer a setback without earning a hero point. Effectively the GM gains a 'free' complication against you.",
        "longDescription": "As a particular side effect of Luck Control, if your effort to alter luck fails, you suffer a setback without earning a hero point. Effectively the GM gains a 'free' complication against you. -1 or -2 cost per rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Efeito Colateral",
            "description": "Como um efeito colateral específico do Controle da Sorte, se seu esforço para alterar a sorte falhar, você sofre um revés sem ganhar um ponto de herói. Efetivamente o Mestre ganha uma complicação 'gratuita' contra você."
          }
        }
      }
    ]
  },
  {
    "id": "mind-reading",
    "name": "Mind Reading",
    "type": "sensory",
    "baseCost": 2,
    "action": "standard",
    "range": "perception",
    "duration": "sustained",
    "description": "You can read another character's mind. Make an opposed effect check vs. target's Will. Degrees of success: 1 = surface thoughts (transcends language), 2 = personal thoughts (ask one question), 3 = memories (one per round), 4 = subconscious (repressed memories, hidden personalities). Target gets a new Will check (DC 10 + rank) each turn to shut you out.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Leitura Mental",
        "description": "Permite ler a mente de outro personagem. Faça um teste de efeito oposto vs. Vontade do alvo. Graus de sucesso: 1 = pensamentos superficiais (transcende idioma), 2 = pensamentos pessoais (faça uma pergunta), 3 = memórias (uma por rodada), 4 = subconsciente (memórias reprimidas, personalidades ocultas). O alvo faz um novo teste de Vontade (CD 10 + rank) a cada turno para bloquear."
      }
    },
    "longDescription": "You can read another character's mind. Make an opposed effect check vs. target's Will. Degrees of success: 1 = surface thoughts (transcends language), 2 = personal thoughts (ask one question), 3 = memories (one per round), 4 = subconscious (repressed memories, hidden personalities). Target gets a new Will check (DC 10 + rank) each turn to shut you out.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "cumulative",
        "name": "Cumulative",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Attempts are cumulative.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Cumulativo",
            "description": "Tentativas são cumulativas."
          }
        }
      },
      {
        "id": "effortless",
        "name": "Effortless",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Retrying after failure doesn't require extra effort.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sem Esforço",
            "description": "Tentar novamente após falha não exige esforço extra."
          }
        }
      },
      {
        "id": "sensory_link",
        "name": "Sensory Link",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can perceive through the target's senses while reading the target's mind. This is essentially a Remote Sensing effect linked to your Mind Reading.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Elo Sensorial",
            "description": "Pode perceber através dos sentidos do alvo enquanto lê a mente do alvo. Isso é essencialmente um efeito de Sensoriamento Remoto vinculado à sua Leitura Mental."
          }
        }
      },
      {
        "id": "subtle_mind_reading",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Your Mind Reading is subtle and difficult to detect. With 2 ranks, it is completely undetectable.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sutil",
            "description": "Sua Leitura Mental é sutil e difícil de detectar. Com 2 ranks, é completamente indetectável."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "close_mind_reading",
        "name": "Close",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Mind Reading requires physical contact with the target.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Próximo",
            "description": "Sua Leitura Mental requer contato físico com o alvo."
          }
        }
      },
      {
        "id": "feedback",
        "name": "Feedback",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "If the target of your Mind Reading succeeds on a resistance check against it with a natural 20, you suffer a mental backlash. You are dazed until the start of your next turn. If you are using the Sensory Link extra, you may also suffer other effects, such as being blinded or deafened, at the GM's discretion.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Retroalimentação",
            "description": "Se o alvo da sua Leitura Mental tiver sucesso em um teste de resistência contra ela com um 20 natural, você sofre um contragolpe mental. Você fica atordoado até o início do seu próximo turno."
          }
        }
      },
      {
        "id": "limited_by_language",
        "name": "Limited by Language",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Mind Reading is limited by language; you can only read the thoughts of subjects whose language you understand.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado por Idioma",
            "description": "Sua Leitura Mental é limitada por idioma; você só pode ler os pensamentos de alvos cujo idioma você entende."
          }
        }
      },
      {
        "id": "limited_to_emotions",
        "name": "Limited to Emotions",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -2,
        "description": "You can only sense the target's emotions, not actual thoughts. This is sometimes called 'empathy' and is more limited than true Mind Reading.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Emoções",
            "description": "Você só pode sentir as emoções do alvo, não pensamentos reais. Isso às vezes é chamado de 'empatia' e é mais limitado que Leitura Mental verdadeira."
          }
        }
      },
      {
        "id": "limited_to_sensory_link",
        "name": "Limited to Sensory Link",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Mind Reading only provides the Sensory Link extra; you cannot read thoughts, only perceive through the target's senses.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Elo Sensorial",
            "description": "Sua Leitura Mental fornece apenas o extra Elo Sensorial; você não pode ler pensamentos, apenas perceber através dos sentidos do alvo."
          }
        }
      },
      {
        "id": "limited_to_surface",
        "name": "Limited to Surface Thoughts",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only read surface thoughts, not deeper memories or subconscious information.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Pensamentos Superficiais",
            "description": "Você só pode ler pensamentos superficiais, não memórias mais profundas ou informações subconscientes."
          }
        }
      },
      {
        "id": "ranged_mind_reading",
        "name": "Ranged",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Mind Reading requires a ranged attack check to use, rather than automatically affecting the target at perception range.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "À Distância",
            "description": "Sua Leitura Mental requer um teste de ataque à distância para usar, ao invés de afetar automaticamente o alvo em alcance de percepção."
          }
        }
      },
      {
        "id": "sense_dependent_mind_reading",
        "name": "Sense-Dependent",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Mind Reading requires a particular sense to work. If that sense is blocked or unavailable, you cannot use Mind Reading.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Dependente de Sentido",
            "description": "Sua Leitura Mental requer um sentido específico para funcionar. Se esse sentido for bloqueado ou indisponível, você não pode usar Leitura Mental."
          }
        }
      }
    ]
  },
  {
    "id": "morph",
    "name": "Morph",
    "type": "general",
    "baseCost": 5,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can alter your appearance (cosmetic change only, no trait changes). Grants +20 to Deception checks for disguise. Rank 1: single other appearance. Rank 2: narrow group (people of your size/gender, one animal type). Rank 3: broad group (humanoids, animals, machines). Rank 4: any form of same mass.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Metamorfose",
        "description": "Permite alterar sua aparência (mudança cosmética apenas, sem alteração de traços). Concede +20 em testes de Enganação para disfarce. Rank 1: uma única outra aparência. Rank 2: grupo restrito (pessoas do seu tamanho/gênero, um tipo de animal). Rank 3: grupo amplo (humanoides, animais, máquinas). Rank 4: qualquer forma da mesma massa."
      }
    },
    "longDescription": "You can alter your appearance (cosmetic change only, no trait changes). Grants +20 to Deception checks for disguise. Rank 1: single other appearance. Rank 2: narrow group (people of your size/gender, one animal type). Rank 3: broad group (humanoids, animals, machines). Rank 4: any form of same mass.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "attack_morph",
        "name": "Attack",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "A Morph Attack imposes a different appearance on the target creature. Unlike an Affliction that imposes the transformed condition, a Morph Attack is entirely cosmetic: you can't change the target's traits other than appearance.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Ataque",
            "description": "Um Ataque de Metamorfose impõe uma aparência diferente na criatura alvo. Diferente de uma Aflição que impõe a condição transformado, um Ataque de Metamorfose é inteiramente cosmético: você não pode mudar os traços do alvo além da aparência."
          }
        }
      },
      {
        "id": "metamorph",
        "name": "Metamorph",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Gain a different set of traits for the form.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Metamorfo",
            "description": "Ganha um conjunto diferente de traços para a forma."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "resistible_morph",
        "name": "Resistible",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "A Morph effect Resistible by Will is most likely a mental illusion of some sort. Observers who succeed on the Will resistance check see you as you truly are rather than in your Morph guise. This is in addition to the usual Perception check to penetrate your disguise.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Resistível",
            "description": "Um efeito de Metamorfose Resistível por Vontade é provavelmente uma ilusão mental de algum tipo. Observadores que têm sucesso no teste de resistência de Vontade veem você como realmente é, em vez de em seu disfarce de Metamorfose. Isso é além do teste de Percepção usual para penetrar seu disfarce."
          }
        }
      }
    ]
  },
  {
    "id": "move-object",
    "name": "Move Object",
    "type": "control",
    "baseCost": 2,
    "action": "standard",
    "range": "ranged",
    "duration": "sustained",
    "description": "You can move objects at a distance without touching them. Effective Strength equals your rank. Concentrate (move action) for +1 STR. Has no action/reaction. Cannot perform fine manipulation without Precise modifier. Objects thrown as attacks use power rank as Strength for damage. Can make disarm, grab, and trip attacks.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Mover Objetos",
        "description": "Permite mover objetos à distância sem tocá-los. Força efetiva igual ao seu rank. Concentre-se (ação de movimento) para +1 FOR. Não tem ação/reação. Não pode fazer manipulação fina sem o modificador Preciso. Objetos arremessados como ataques usam o rank do poder como Força para dano. Pode fazer ataques de desarmar, agarrar e derrubar."
      }
    },
    "longDescription": "You can move objects at a distance without touching them. Effective Strength equals your rank. Concentrate (move action) for +1 STR. Has no action/reaction. Cannot perform fine manipulation without Precise modifier. Objects thrown as attacks use power rank as Strength for damage. Can make disarm, grab, and trip attacks.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "continuous_move_object",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Move Object is not disrupted when you are unable to maintain it, but still requires conscious attention.",
        "longDescription": "Move Object generally cannot have a continuous duration, since it is an active effect and requires at least a modicum of attention to maintain. The GM may allow Continuous Move Object as a variation that is not disrupted when you are unable to maintain it, but that still requires your conscious attention to do anything other than have the affected object hang in midair. There's no change in the cost of the extra, this is just a limitation of the Move Object effect.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "damaging",
        "name": "Damaging",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Your effect can inflict damage, like an application of normal Strength with damage equal to its rank.",
        "longDescription": "Your effect can inflict damage, like an application of normal Strength with damage equal to its rank. This includes damaging targets in grabs and making ranged \"strike\" attacks.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Causar Dano",
            "description": "Usa Mover Objetos para infligir dano."
          }
        }
      },
      {
        "id": "improvised_weapon_move_object",
        "name": "Improvised Weapon or Throwing Mastery",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "You are particularly adept at using objects as weapons with your power. Each rank increases damage by 1.",
        "longDescription": "You are particularly adept at using objects as weapons with your power. Each rank of either advantage increases the damage of objects wielded or thrown using Move Object by 1.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "perception_move_object",
        "name": "Perception",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Perception Ranged Move Object can affect any object you can accurately perceive, with no need for an attack check.",
        "longDescription": "Perception Ranged Move Object can affect any object you can accurately perceive, with no need for an attack check.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Percepção",
            "description": "Move qualquer coisa que possa ver."
          }
        }
      },
      {
        "id": "precise_move_object",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Move Object with this modifier can be used for tasks involving fine manipulation.",
        "longDescription": "Move Object with this modifier can be used for tasks involving fine manipulation.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "subtle_move_object",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "A less noticeable Move Object effect, such as invisible psychokinesis.",
        "longDescription": "The default version of Move Object involves some noticeable manifestation like a \"tractor beam,\" a glow around your head or hands (along with a corresponding glow around the affected object), big glowing hands, blazing \"energy talons,\" a lasso, whip, or the like. Apply the Subtle modifier for a less noticeable Move Object effect, such as invisible \"psychokinesis\" (which is generally also Perception Range).",
        "incompatibleWith": [],
        "i18n": {}
      }
    ],
    "flaws": [
      {
        "id": "close_move_object",
        "name": "Close",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Move Object is reduced to close range. May represent \"tactile telekinesis\" or supernatural influence over touched objects.",
        "longDescription": "Since Move Object works on things at a distance by definition, it cannot generally be reduced to close ranged. At the GM's discretion, a Close Ranged Move Object effect may represent \"tactile telekinesis\" or a supernatural influence over objects you are able to touch, but such things are usually better represented by the Enhanced Strength effect.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "concentration_move_object",
        "name": "Concentration",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Concentration Move Object requires more attention to maintain. You cannot concentrate to increase lifting capacity or grab/move another object while holding the first.",
        "longDescription": "Concentration Move Object requires more attention to maintain. You cannot concentrate to increase your lifting capacity or to grab or move another object while you are still \"holding\" your first.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "limited_direction",
        "name": "Limited Direction",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only move objects in a particular direction or path, such as only up and down, or only towards/away from you.",
        "longDescription": "You can only move objects in a particular direction or path, such as only up and down (towards and away from the ground), only directly towards or away from you (attraction and repulsion), and so forth. This is useful for \"gravitic\" or \"magnetic\" versions of the effect.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Direção Limitada",
            "description": "Move apenas em uma direção."
          }
        }
      },
      {
        "id": "limited_material",
        "name": "Limited Material",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "repeatable": true,
        "description": "You can only move a particular type of object or material, such as only metals, plants, rock, water, etc.",
        "longDescription": "You can only move a particular type of object or material, such as only metals, plants, rock, water, and so forth. The GM may allow a –2 cost per rank flaw for a particularly limited type of material, such as only precious metals, leaves, sand, or petroleum.",
        "incompatibleWith": [],
        "i18n": {}
      }
    ]
  },
  {
    "id": "movement",
    "name": "Movement",
    "type": "movement",
    "baseCost": 2,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You have a special form of movement. Each rank provides one option: Dimension Travel (1-3 ranks), Environmental Adaptation, Permeate (1-3 ranks), Safe Fall, Slithering, Space Travel (1-3 ranks), Sure-Footed, Swinging, Time Travel (1-3 ranks), Trackless, Wall-Crawling (1-2 ranks), or Water-Walking (1-2 ranks).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Movimento",
        "description": "Possui uma forma especial de movimento. Cada rank fornece uma opção: Viagem Dimensional (1-3 ranks), Adaptação Ambiental, Permear (1-3 ranks), Queda Segura, Deslizar, Viagem Espacial (1-3 ranks), Pé Firme, Balançar, Viagem no Tempo (1-3 ranks), Sem Rastro, Escalar Paredes (1-2 ranks), ou Andar sobre a Água (1-2 ranks)."
      }
    },
    "longDescription": "You have a special form of movement. Each rank provides one option: Dimension Travel (1-3 ranks), Environmental Adaptation, Permeate (1-3 ranks), Safe Fall, Slithering, Space Travel (1-3 ranks), Sure-Footed, Swinging, Time Travel (1-3 ranks), Trackless, Wall-Crawling (1-2 ranks), or Water-Walking (1-2 ranks).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "portal_movement",
        "name": "Portal",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "Open a passage others can use with a travel option, such as Space Travel or Dimensional Travel.",
        "longDescription": "A travel effect creates a portal others can cross. Power Profiles Space Warp uses Movement (Space Travel) with Portal, +2 cost per rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Portal",
            "description": "Abre uma passagem que outras pessoas podem usar com uma opção de viagem, como Viagem Espacial ou Dimensional."
          }
        }
      }
    ],
    "flaws": []
  },
  {
    "id": "nullify",
    "name": "Nullify",
    "type": "attack",
    "baseCost": 1,
    "action": "standard",
    "range": "ranged",
    "duration": "instant",
    "description": "You can counter effects of a particular descriptor (fire, magic, mental, etc.). Make a ranged attack check, then an opposed check of Nullify rank vs. effect rank or target's Will (whichever is higher). Success: targeted effect turns off (can be reactivated). Two+ degrees of failure: extra effort required to retry in same scene. Cannot nullify innate effects.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "descriptor",
        "label": "Power Descriptor",
        "control": "text",
        "required": true,
        "placeholder": "e.g., Fire, Magic, Mental, Technology",
        "i18n": {
          "pt-BR": {
            "label": "Descritor do Poder",
            "placeholder": "ex: Fogo, Magia, Mental, Tecnologia"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Anulação",
        "description": "Permite anular efeitos de um descritor específico (fogo, magia, mental, etc.). Faça teste de ataque à distância, depois teste oposto de rank de Anulação vs. rank do efeito ou Vontade do alvo (o maior). Sucesso: efeito alvo é desativado (pode ser reativado). Dois+ graus de falha: esforço extra necessário para tentar novamente na cena. Não pode anular efeitos inatos."
      }
    },
    "longDescription": "Nullify temporarily cancels powers with the chosen descriptor. It is a ranged attack requiring an attack check. The target resists with Will vs. DC [10 + rank]. If successful, the described powers within rank points of the Nullify rank are cancelled until the target succeeds on a Will check (free action each turn, DC = Nullify rank + 10 − margin of failure). Nullify only affects powers matching the chosen descriptor.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "broad",
        "name": "Broad",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Nullify affects a broad category of powers rather than a single descriptor.",
        "longDescription": "Broad Nullify affects all powers with any descriptor within a wide category (e.g., all mental powers, all elemental powers, all technology) rather than one specific descriptor.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Amplo",
            "description": "Anular afeta uma categoria ampla de poderes em vez de um único descritor.",
            "longDescription": "Anular Amplo afeta todos os poderes com qualquer descritor dentro de uma categoria larga (ex: todos os poderes mentais) em vez de um específico."
          }
        }
      },
      {
        "id": "simultaneous",
        "name": "Simultaneous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Simultaneous Nullify can counter all effects of a particular descriptor (such as fire or magic) at once.",
        "longDescription": "Simultaneous Nullify can counter all effects of a particular descriptor (such as fire or magic) at once.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Simultâneo",
            "description": "Anular Simultâneo pode anular todos os efeitos de um descritor específico (como fogo ou magia) de uma vez."
          }
        }
      },
      {
        "id": "alternate_resistance",
        "name": "Alternate Resistance",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Nullify may require a Fortitude rather than a Will check to represent an effect resisted by health and stamina rather than strength of will.",
        "longDescription": "Nullify may require a Fortitude rather than a Will check to represent an effect resisted by health and stamina rather than strength of will.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Resistência Alternativa",
            "description": "Anular pode exigir um teste de Fortitude ao invés de Vontade para representar um efeito resistido por saúde e vigor ao invés de força de vontade."
          }
        }
      },
      {
        "id": "area_nullify",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "An Area Nullify effect works on all targets in the area. Make a single power check and compare the result against the opposed checks of the targets. Targets lacking effects you can nullify are, naturally, unaffected.",
        "longDescription": "An Area Nullify effect works on all targets in the area. Make a single power check and compare the result against the opposed checks of the targets. Targets lacking effects you can nullify are, naturally, unaffected. If your Area Nullify has a duration longer than instant, choose whether or not the effect remains in the chosen area (affecting anyone entering or leaving it) or moves with the targets hit with the initial effect.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Área",
            "description": "Anular em Área funciona em todos os alvos na área. Faça um único teste de poder e compare o resultado contra os testes opostos dos alvos. Alvos sem efeitos que você possa anular não são afetados."
          }
        }
      },
      {
        "id": "concentration_nullify",
        "name": "Concentration",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Any countered effect is suppressed and cannot be re-activated while you concentrate. The user of the countered effect may use extra effort to gain another opposed Nullify check. If successful, the effect can be re-activated.",
        "longDescription": "Any countered effect is suppressed and cannot be re-activated while you concentrate. The user of the countered effect may use extra effort to gain another opposed Nullify check. If successful, the effect can be re-activated.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Concentração",
            "description": "Qualquer efeito anulado é suprimido e não pode ser reativado enquanto você se concentra. O usuário do efeito anulado pode usar esforço extra para obter outro teste oposto de Anular."
          }
        }
      },
      {
        "id": "effortless_nullify",
        "name": "Effortless",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Trying again after two or more degrees of failure does not require extra effort for you. You can retry a Nullify attempt an unlimited number of times.",
        "longDescription": "Trying again after two or more degrees of failure does not require extra effort for you. You can retry a Nullify attempt an unlimited number of times.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sem Esforço",
            "description": "Tentar novamente após dois ou mais graus de falha não requer esforço extra. Você pode tentar Anular um número ilimitado de vezes."
          }
        }
      },
      {
        "id": "precise_nullify",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "If you can Nullify multiple effects, this modifier allows you to choose which are nullified and which are not.",
        "longDescription": "If you can Nullify multiple effects, this modifier allows you to choose which are nullified and which are not.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Preciso",
            "description": "Se você pode Anular múltiplos efeitos, este modificador permite escolher quais são anulados e quais não são."
          }
        }
      },
      {
        "id": "randomize",
        "name": "Randomize",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Rather than being countered, the effect(s) targeted by your Nullify acquire the Uncontrolled flaw and go out of control (as dictated by the GM).",
        "longDescription": "Rather than being countered, the effect(s) targeted by your Nullify acquire the Uncontrolled flaw and go out of control (as dictated by the GM).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Aleatorizar",
            "description": "Ao invés de ser anulado, o(s) efeito(s) alvo do seu Anular adquirem a falha Descontrolado e saem de controle (conforme ditado pelo Mestre)."
          }
        }
      },
      {
        "id": "selective_nullify",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "If you have an Area Nullify effect, this extra allows you to choose who in the area is affected, nullifying some targets and not others.",
        "longDescription": "If you have an Area Nullify effect, this extra allows you to choose who in the area is affected, nullifying some targets and not others.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Se você tem um efeito Anular em Área, este extra permite escolher quem na área é afetado, anulando alguns alvos e não outros."
          }
        }
      },
      {
        "id": "sustained_nullify",
        "name": "Sustained",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "If this modifier is applied to Concentration Nullify, keeping the countered effect(s) suppressed is only a free action for you each turn.",
        "longDescription": "If this modifier is applied to Concentration Nullify, keeping the countered effect(s) suppressed is only a free action for you each turn.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sustentado",
            "description": "Se este modificador for aplicado a Anular com Concentração, manter o(s) efeito(s) anulado(s) suprimido(s) é apenas uma ação livre para você a cada turno."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "side_effect_nullify",
        "name": "Side Effect",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "If you fail to nullify an effect, you might suffer some kind of 'backlash' or similar side effect.",
        "longDescription": "If you fail to nullify an effect, you might suffer some kind of 'backlash' or similar side effect.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Efeito Colateral",
            "description": "Se você falhar em anular um efeito, pode sofrer algum tipo de 'contragolpe' ou efeito colateral similar."
          }
        }
      }
    ]
  },
  {
    "id": "protection",
    "name": "Protection",
    "type": "defense",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "Shields you against damage, giving you +1 to your Toughness defense per rank. So Protection 4 gives you +4 Toughness. Can be made Sustained (activatable force field) or Impervious (immune to lower-threshold Damage).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Proteção",
        "description": "Protege contra dano, concedendo +1 à defesa de Resistência por rank. Proteção 4 concede +4 de Resistência. Pode ser Sustentado (campo de força ativável) ou Impenetrável (imune a Dano abaixo de um limiar)."
      }
    },
    "longDescription": "Protection is a flat bonus to Toughness equal to its rank. Unlike armored heroes, Protection is usually an internal power (force field, body armor, toughened skin, etc.). Each rank of Protection improves Toughness by 1. Protection can be stacked with other Toughness bonuses (like natural Stamina). Note: stacked Protection above PL limits is subject to GM approval.",
    "enhancesDefense": "toughness",
    "extras": [],
    "flaws": [
      {
        "id": "sustained_protection",
        "name": "Sustained",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": 0,
        "description": "Your Protection is a sustained effect, rather than permanent. The effect can be turned on and off and can be improved using extra effort, including using it to perform stunts. Sustained Protection might be a power like a personal force field, or the ability to consciously harden your skin and turn it into armor.",
        "longDescription": "Sustained Protection changes the duration from permanent to sustained. It is a net +0 modifier from Protection's base permanent duration. This allows the effect to be turned on and off, improved with extra effort, and used for power stunts.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sustentado",
            "description": "Sua Proteção é um efeito sustentado, ao invés de permanente. O efeito pode ser ligado e desligado e pode ser melhorado usando esforço extra, incluindo usá-lo para realizar truques. Proteção Sustentada pode ser um poder como um campo de força pessoal, ou a habilidade de conscientemente endurecer sua pele e transformá-la em armadura."
          }
        }
      }
    ]
  },
  {
    "id": "quickness",
    "name": "Quickness",
    "type": "general",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can perform routine tasks fast. Subtract your effect rank from the normal time rank. So Quickness 7 turns a task normally taking 1 hour (time rank 9) into 30 seconds (time rank 2). Does not affect non-routine checks or movement speed. Tasks performed in less than 1 second may be treated as free actions.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Rapidez",
        "description": "Permite realizar tarefas rotineiras rapidamente. Subtraia seu rank do efeito do rank de tempo normal. Rapidez 7 transforma uma tarefa de 1 hora (rank de tempo 9) em 30 segundos (rank de tempo 2). Não afeta testes não-rotineiros nem velocidade de movimento. Tarefas realizadas em menos de 1 segundo podem ser tratadas como ações livres."
      }
    },
    "longDescription": "You can perform routine tasks fast. Subtract your effect rank from the normal time rank. So Quickness 7 turns a task normally taking 1 hour (time rank 9) into 30 seconds (time rank 2). Does not affect non-routine checks or movement speed. Tasks performed in less than 1 second may be treated as free actions.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": [
      {
        "id": "limited_to_one_type",
        "name": "Limited to One Type",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Quickness applies to only physical or mental tasks, not both.",
        "longDescription": "Your Quickness applies to only physical or mental tasks, not both. This limits the versatility of the effect significantly.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Um Tipo",
            "description": "Sua Rapidez se aplica apenas a tarefas físicas ou mentais, não ambas."
          }
        }
      },
      {
        "id": "limited_to_one_task",
        "name": "Limited to One Task",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -2,
        "description": "Your Quickness applies to only one particular task, such as reading, mathematical calculations, and so forth.",
        "longDescription": "Your Quickness applies to only one particular task, such as reading, mathematical calculations, and so forth. This severely limits the effect to a very narrow application.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Uma Tarefa",
            "description": "Sua Rapidez se aplica apenas a uma tarefa específica, como leitura, cálculos matemáticos, etc."
          }
        }
      }
    ]
  },
  {
    "id": "regeneration",
    "name": "Regeneration",
    "type": "defense",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "You recover quickly from damage. Remove Toughness check penalties equal to your rank each minute, then recover other damage conditions equal to rank each minute (spread evenly over 10 rounds). Regeneration 5: remove -1 penalty every other round. Regeneration 10: every round. Characters with no Stamina need at least 1 rank to recover at normal rate.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Regeneração",
        "description": "Recupera-se rapidamente de dano. Remove penalidades de testes de Resistência iguais ao seu rank a cada minuto, depois recupera outras condições de dano iguais ao rank a cada minuto (distribuídas em 10 rodadas). Regeneração 5: remove -1 a cada 2 rodadas. Regeneração 10: a cada rodada. Personagens sem Vigor precisam de ao menos 1 rank para se recuperar normalmente."
      }
    },
    "longDescription": "You recover quickly from damage. Remove Toughness check penalties equal to your rank each minute, then recover other damage conditions equal to rank each minute (spread evenly over 10 rounds). Regeneration 5: remove -1 penalty every other round. Regeneration 10: every round. Characters with no Stamina need at least 1 rank to recover at normal rate.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "persistent",
        "name": "Persistent",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can regenerate even Incurable damage conditions (see the Incurable modifier).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Persistente",
            "description": "Você pode regenerar até condições de dano Incuráveis (veja o modificador Incurável)."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "source",
        "name": "Source",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your Regeneration only works when you have access to a particular source to replenish yourself, such as blood, electricity, sand, scrap metal, sunlight, and so forth.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Fonte",
            "description": "Sua Regeneração só funciona quando você tem acesso a uma fonte específica para se repor, como sangue, eletricidade, areia, sucata, luz solar, etc."
          }
        }
      }
    ]
  },
  {
    "id": "remote-sensing",
    "name": "Remote Sensing",
    "type": "sensory",
    "baseCost": 1,
    "action": "free",
    "range": "ranged",
    "duration": "sustained",
    "description": "You can displace one or more senses over a distance. Rank 1 = 60 feet, increasing one distance rank per rank. Overrides normal senses while active; you are vulnerable. Subjects feel it with Insight check (DC 10 + rank). Cost: 1 pt/rank for one sense type, 2 for two, 3 for three, 4 for four, 5 for all (visual = 2 types).",
    "variableCost": {
      "options": [
        {
          "name": "One sense type",
          "cost": 1
        },
        {
          "name": "Two sense types (or Visual)",
          "cost": 2
        },
        {
          "name": "Three sense types",
          "cost": 3
        },
        {
          "name": "Four sense types",
          "cost": 4
        },
        {
          "name": "All sense types",
          "cost": 5
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Sensoriamento Remoto",
        "description": "Permite deslocar um ou mais sentidos à distância. Rank 1 = 18 m, aumentando um rank de distância por rank. Substitui os sentidos normais enquanto ativo; você fica vulnerável. Alvos sentem com teste de Intuição (CD 10 + rank). Custo: 1 pp/rank para um tipo de sentido, 2 para dois, 3 para três, 4 para quatro, 5 para todos (visual = 2 tipos)."
      }
    },
    "longDescription": "You can displace one or more senses over a distance. Rank 1 = 60 feet, increasing one distance rank per rank. Overrides normal senses while active; you are vulnerable. Subjects feel it with Insight check (DC 10 + rank). Cost: 1 pt/rank for one sense type, 2 for two, 3 for three, 4 for four, 5 for all (visual = 2 types).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "dimensional",
        "name": "Dimensional",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Sense into other dimensions.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Dimensional",
            "description": "Percebe em outras dimensões."
          }
        }
      },
      {
        "id": "no_conduit",
        "name": "No Conduit",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Sensory effects targeted where you have displaced your senses do not affect you, but neither can you use perception ranged effects via your Remote Sensing.",
        "longDescription": "Sensory effects targeted where you have displaced your senses do not affect you, but neither can you use perception ranged effects via your Remote Sensing. Despite the built-in limitation, this is an extra, since it allows you to use your Remote Sensing to observe subjects in relative safety.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "simultaneous",
        "name": "Simultaneous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Use normal senses and Remote Sensing at the same time.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Simultâneo",
            "description": "Usa sentidos normais e remotos ao mesmo tempo."
          }
        }
      },
      {
        "id": "subtle",
        "name": "Subtle",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Harder to notice (1 rank) or undetectable (2 ranks).",
        "maxRanks": 2,
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sutil",
            "description": "Mais difícil de notar ou indetectável."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "feedback",
        "name": "Feedback",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Damaging attacks at the remote location can affect you.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Retroalimentação",
            "description": "Ataques no local remoto podem te afetar."
          }
        }
      },
      {
        "id": "medium",
        "name": "Medium",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Requires a medium (e.g., mirrors, water).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Meio",
            "description": "Exige um meio (ex: espelhos, água)."
          }
        }
      },
      {
        "id": "noticeable",
        "name": "Noticeable",
        "category": "flaw",
        "costType": "flat",
        "costValue": -1,
        "description": "Has a noticeable manifestation (e.g., glowing eyes).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Perceptível",
            "description": "Possui uma manifestação visível."
          }
        }
      }
    ]
  },
  {
    "id": "senses",
    "name": "Senses",
    "type": "sensory",
    "baseCost": 1,
    "action": "none",
    "range": "personal",
    "duration": "permanent",
    "description": "One or more of your senses are improved or you have additional sensory abilities. Allocate ranks to: Accurate (2/4), Acute (1/2), Analytical (1/2), Awareness (1), Communication Link (1), Counters Concealment (2/5), Counters Illusion (2), Danger Sense (1), Darkvision (2), Detect (1/2), Direction Sense (1), Distance Sense (1), Extended (1+), Infravision (1), Low-Light Vision (1), Microscopic Vision (1-4), Penetrates Concealment (4), Postcognition (4), Precognition (4), Radio (1), Radius (1/2), Ranged (1), Rapid (1+), Time Sense (1), Tracking (1/2), Ultra-Hearing (1), Ultravision (1).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Sentidos",
        "description": "Um ou mais de seus sentidos são aprimorados ou você possui habilidades sensoriais adicionais. Aloque ranks em: Preciso (2/4), Agudo (1/2), Analítico (1/2), Consciência (1), Elo de Comunicação (1), Anula Camuflagem (2/5), Anula Ilusão (2), Senso de Perigo (1), Visão no Escuro (2), Detectar (1/2), Senso de Direção (1), Senso de Distância (1), Estendido (1+), Infravisão (1), Visão em Luz Baixa (1), Visão Microscópica (1-4), Penetra Ocultação (4), Pós-cognição (4), Precognição (4), Rádio (1), Raio (1/2), Distância (1), Rápido (1+), Senso de Tempo (1), Rastreamento (1/2), Ultra-Audição (1), Ultravisão (1)."
      }
    },
    "longDescription": "One or more of your senses are improved or you have additional sensory abilities. Allocate ranks to: Accurate (2/4), Acute (1/2), Analytical (1/2), Awareness (1), Communication Link (1), Counters Concealment (2/5), Counters Illusion (2), Danger Sense (1), Darkvision (2), Detect (1/2), Direction Sense (1), Distance Sense (1), Extended (1+), Infravision (1), Low-Light Vision (1), Microscopic Vision (1-4), Penetrates Concealment (4), Postcognition (4), Precognition (4), Radio (1), Radius (1/2), Ranged (1), Rapid (1+), Time Sense (1), Tracking (1/2), Ultra-Hearing (1), Ultravision (1).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "affects_others",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Grant the sense to another character.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Outros",
            "description": "Concede o sentido a outro personagem."
          }
        }
      },
      {
        "id": "area_senses",
        "name": "Area",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "The Area modifier only applies to Senses that Affect Others, extending their benefits to everyone in an area.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Área",
            "description": "O modificador Área só se aplica a Sentidos que Afetam Outros, estendendo seus benefícios a todos em uma área."
          }
        }
      },
      {
        "id": "dimensional_senses",
        "name": "Dimensional",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "This modifier allows you to extend your senses into other dimensions. It's assumed to apply to all your senses, allowing you to sense your proximate location in the other dimension(s).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Dimensional",
            "description": "Este modificador permite estender seus sentidos para outras dimensões. Assume-se que se aplica a todos os seus sentidos, permitindo sentir sua localização próxima na(s) outra(s) dimensão(ões)."
          }
        }
      },
      {
        "id": "innate_senses",
        "name": "Innate",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Senses, particularly those of aliens or constructs like robots, may be Innate, although this does not prevent sensory effects like Concealment or Dazzle from disabling them.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Inato",
            "description": "Sentidos, particularmente de alienígenas ou construtos como robôs, podem ser Inatos, embora isso não impeça efeitos sensoriais como Camuflagem ou Ofuscamento de desabilitá-los."
          }
        }
      },
      {
        "id": "ranged_senses",
        "name": "Ranged",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "The Ranged extra only applies to Senses that Affect Others, extending the distance at which you can grant their benefits.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "À Distância",
            "description": "O extra À Distância só se aplica a Sentidos que Afetam Outros, estendendo a distância na qual você pode conceder seus benefícios."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "limited_senses",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Some Senses may be Limited to only sensing certain things or only under certain circumstances. The sense must lose about half its utility to qualify for this flaw.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "Alguns Sentidos podem ser Limitados a apenas sentir certas coisas ou apenas sob certas circunstâncias. O sentido deve perder cerca de metade de sua utilidade para se qualificar para esta falha."
          }
        }
      },
      {
        "id": "noticeable",
        "name": "Noticeable",
        "category": "flaw",
        "costType": "flat",
        "costValue": -1,
        "description": "The sense has a noticeable manifestation.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Perceptível",
            "description": "O sentido possui uma manifestação visível."
          }
        }
      },
      {
        "id": "unreliable",
        "name": "Unreliable",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Some Senses may be unreliable; the GM makes checks for reliability when the sense is used. When it doesn't work, the character perceives nothing with that sense, or gets wrong information.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Não Confiável",
            "description": "Alguns Sentidos podem ser não confiáveis; o Mestre faz testes de confiabilidade quando o sentido é usado. Quando não funciona, o personagem não percebe nada com aquele sentido, ou recebe informações erradas."
          }
        }
      }
    ]
  },
  {
    "id": "shrinking",
    "name": "Shrinking",
    "type": "general",
    "baseCost": 2,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can temporarily decrease your size. Every 4 ranks reduces size rank by 1 (normal humans are -2). Each size rank reduction: -1 Strength, every 2 reductions: -1 speed. Add half rank (rounded down) to active defenses. Add full rank to Stealth. Apply half rank as Intimidation penalty. Shrinking modifiers restricted by power level.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Encolhimento",
        "description": "Permite diminuir temporariamente seu tamanho. A cada 4 ranks, reduz o rank de tamanho em 1 (humanos normais são -2). Cada redução de tamanho: -1 Força, a cada 2 reduções: -1 velocidade. Adicione metade do rank (arredondado para baixo) às defesas ativas. Adicione o rank inteiro à Furtividade. Aplique metade do rank como penalidade em Intimidação. Limitado pelo nível de poder."
      }
    },
    "longDescription": "You can temporarily decrease your size. Every 4 ranks reduces size rank by 1 (normal humans are -2). Each size rank reduction: -1 Strength, every 2 reductions: -1 speed. Add half rank (rounded down) to active defenses. Add full rank to Stealth. Apply half rank as Intimidation penalty. Shrinking modifiers restricted by power level.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "atomic",
        "name": "Atomic",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Shrink to atomic level and pass through solid objects (at rank 20).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Atômico",
            "description": "Encolhe ao nível atômico e atravessa objetos (no rank 20)."
          }
        }
      },
      {
        "id": "normal_strength",
        "name": "Normal Strength",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Retain full Strength, Speed, and Intimidation while shrunk.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Força Normal",
            "description": "Mantém Força, Velocidade e Intimidação normais enquanto encolhido."
          }
        }
      }
    ],
    "flaws": []
  },
  {
    "id": "speed",
    "name": "Speed",
    "type": "movement",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can move faster than normal. You have a ground speed rank equal to your effect rank. This also improves all forms of movement based on ground speed.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Velocidade",
        "description": "Permite mover-se mais rápido que o normal. Você possui um rank de velocidade terrestre igual ao rank do efeito. Isso também melhora todas as formas de movimento baseadas em velocidade terrestre."
      }
    },
    "longDescription": "You can move faster than normal. You have a ground speed rank equal to your effect rank. This also improves all forms of movement based on ground speed.",
    "enhancesDefense": null,
    "extras": [],
    "flaws": []
  },
  {
    "id": "summon",
    "name": "Summon",
    "type": "control",
    "baseCost": 2,
    "action": "standard",
    "range": "close",
    "duration": "sustained",
    "description": "You can call upon a creature (minion) to aid you. Created with (rank x 15) power points, limited to your Summon rank power level. Summon automatically as standard action; appears beside you. Minions are dazed (standard action only). Directing a minion is a move action. Incapacitated minions disappear and must fully recover before re-summoning. Always the same minion unless Variable Type.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Invocar",
        "description": "Permite convocar uma criatura (lacaio) para auxiliá-lo. Criada com (rank x 15) pontos de poder, limitada ao nível de poder do rank de Invocar. Invoque automaticamente como ação padrão; aparece ao seu lado. Lacaios ficam atordoados (apenas ação padrão). Dirigir um lacaio é uma ação de movimento. Lacaios incapacitados desaparecem e devem se recuperar totalmente antes de reinvocação. Sempre o mesmo lacaio, exceto com Tipo Variável."
      }
    },
    "longDescription": "Summon creates or calls a controlled minion whose power total equals 15 × rank. The summoned creature is a separate character sheet NPCs with its own traits. It acts on your turn and follows your orders (free action to command). If the creature is incapacitated or you lose concentration, it disappears. The minion cannot act against your wishes. Flaw: the summoned creature has its own agenda (Uncontrolled variant).",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "active",
        "name": "Active",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Minions are not dazed and have a full set of actions.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Ativo",
            "description": "Lacaios não ficam pasmos e têm todas as ações."
          }
        }
      },
      {
        "id": "controlled",
        "name": "Controlled",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Minions are completely under your direction.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Controlado",
            "description": "Lacaios estão sob sua direção completa."
          }
        }
      },
      {
        "id": "heroic",
        "name": "Heroic",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "The summoned creature is a normal NPC, not a minion.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Heroico",
            "description": "A criatura é um NPC normal, não um lacaio."
          }
        }
      },
      {
        "id": "horde",
        "name": "Horde",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Summon all minions at once as a standard action.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Horda",
            "description": "Invoca todos os lacaios de uma vez."
          }
        }
      },
      {
        "id": "mental_link",
        "name": "Mental Link",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "You have a mental link with your minions, allowing you to communicate with them and issue orders telepathically like the Communication Link effect.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "multiple_minions",
        "name": "Multiple Minions",
        "category": "extra",
        "costType": "flat_ranked",
        "costValue": 2,
        "description": "Each purchase doubles the number of minions. Legacy flat +2 PP per purchase, preserved for existing characters. Use Multiple Minions (per effect rank) for the official +2 PP per Summon rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Múltiplos Servos",
            "description": "Cada compra dobra a quantidade de lacaios. Preço legado de +2 PP fixos por compra preservado para personagens existentes. Use Múltiplos Lacaios (por graduação do efeito) para o custo oficial de +2 PP por graduação de Invocar."
          }
        }
      },
      {
        "id": "sacrifice",
        "name": "Sacrifice",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Shift a resistance check to one of your minions.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Sacrifício",
            "description": "Transfere um teste de resistência para um lacaio."
          }
        }
      },
      {
        "id": "variable_type_general",
        "name": "Variable Type (General)",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can summon different minions of a general type (like elementals, birds, fish, etc.).",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "variable_type_broad",
        "name": "Variable Type (Broad)",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "You can summon different minions of a broad type (like animals, demons, humanoids, etc.).",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "multiple_minions_ranked",
        "name": "Multiple Minions (per effect rank)",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "repeatable": true,
        "maxRanks": 20,
        "description": "Each purchase doubles the number of minions and adds 2 PP per Summon rank.",
        "longDescription": "Each application doubles the number of summoned minions and adds +2 cost per rank of Summon. The original flat-price modifier is retained for existing characters. Deluxe Hero’s Handbook, Summon: Multiple Minions.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Múltiplos Lacaios (por graduação do efeito)",
            "description": "Cada compra dobra a quantidade de lacaios e acrescenta 2 PP por graduação de Invocar.",
            "longDescription": "Cada aplicação dobra a quantidade de lacaios e custa +2 por graduação de Invocar. O modificador original com custo fixo é preservado para personagens existentes. Deluxe Hero’s Handbook, Summon: Multiple Minions."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "attitude_indifferent",
        "name": "Attitude (Indifferent)",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Your summoned minions are indifferent. You can use interaction skills and other effects to get your summoned minions to cooperate, but success is by no means assured.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "attitude_unfriendly",
        "name": "Attitude (Unfriendly)",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -2,
        "description": "Your summoned minions are unfriendly. You can use interaction skills and other effects to get your summoned minions to cooperate, but success is by no means assured.",
        "incompatibleWith": [],
        "i18n": {}
      },
      {
        "id": "resistible",
        "name": "Resistible",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Minions get a resistance check to avoid being summoned.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Resistível",
            "description": "Lacaios fazem teste para evitar a invocação."
          }
        }
      },
      {
        "id": "self_powered",
        "name": "Self-Powered",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Summoned agents must travel to the summoner using their own movement.",
        "longDescription": "The summoned agents do not appear near the summoner. They must travel there from their current location using their own movement. Power Profiles p. 181. -1 cost per rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Deslocamento Próprio",
            "description": "Os agentes invocados precisam viajar até o invocador com seu próprio movimento."
          }
        }
      }
    ]
  },
  {
    "id": "swimming",
    "name": "Swimming",
    "type": "movement",
    "baseCost": 1,
    "action": "free",
    "range": "personal",
    "duration": "sustained",
    "description": "You can swim fast. You have a water speed equal to your Swimming rank minus 2. You can make Athletics checks to swim as routine checks. Does not allow you to breathe underwater (requires Immunity).",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Natação",
        "description": "Permite nadar rapidamente. Velocidade aquática igual ao rank de Natação menos 2. Pode fazer testes de Atletismo para nadar como testes rotineiros. Não permite respirar debaixo d'água (requer Imunidade)."
      }
    },
    "longDescription": "You can swim fast. You have a water speed equal to your Swimming rank minus 2. You can make Athletics checks to swim as routine checks. Does not allow you to breathe underwater (requires Immunity).",
    "enhancesDefense": null,
    "extras": [],
    "flaws": []
  },
  {
    "id": "teleport",
    "name": "Teleport",
    "type": "movement",
    "baseCost": 2,
    "action": "move",
    "range": "ranged",
    "duration": "instant",
    "description": "You can move instantly from place to place. Teleport yourself and up to 50 lbs. of additional mass a distance rank equal to your effect rank as a move action. Unwilling passengers get Dodge resistance. Can only teleport to places you can accurately sense or know well. You retain position and relative velocity.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Teleporte",
        "description": "Permite mover-se instantaneamente de um lugar para outro. Teleporte a si mesmo e até 22 kg de massa adicional uma distância igual ao rank do efeito como ação de movimento. Passageiros involuntários fazem teste de resistência de Esquiva. Só pode teleportar para lugares que pode perceber com precisão ou conhece bem. Mantém posição e velocidade relativa."
      }
    },
    "longDescription": "Teleport allows instant movement from one location to another at range, limited by rank. Rank 1 = 100 ft, Rank 5 = 5 miles, Rank 10 = worldwide, Rank 15 = interplanetary, Rank 20 = anywhere. Teleport requires a free action to a known location, or a standard action if uncertain. You can carry others with you (up to normal carrying capacity). Targeting a location with Teleport is not an attack.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "accurate_teleport",
        "name": "Accurate",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "No need to know the destination to teleport there.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Preciso",
            "description": "Não precisa conhecer o destino para teleportar."
          }
        }
      },
      {
        "id": "change_direction",
        "name": "Change Direction",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Change orientation after teleporting.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Mudar Direção",
            "description": "Muda a orientação após o teleporte."
          }
        }
      },
      {
        "id": "change_velocity",
        "name": "Change Velocity",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Teleport 'at rest' to your destination.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Mudar Velocidade",
            "description": "Teleporta em repouso ao destino."
          }
        }
      },
      {
        "id": "portal",
        "name": "Portal",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "Creates a two-way portal others can use.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Portal",
            "description": "Cria um portal bidirecional que outros podem usar."
          }
        }
      },
      {
        "id": "turnabout",
        "name": "Turnabout",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Teleport, act, and teleport back in one round.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Retorno",
            "description": "Teleporta, age e volta no mesmo turno."
          }
        }
      },
      {
        "id": "easy",
        "name": "Easy",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You are not dazed or vulnerable when making extended teleports.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Fácil",
            "description": "Você não fica atordoado ou vulnerável ao fazer teleportes estendidos."
          }
        }
      },
      {
        "id": "extended",
        "name": "Extended",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can take two move actions to make an extended teleport with a distance rank equal to your effect rank +8. You are dazed and vulnerable for one round after an extended teleport.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Estendido",
            "description": "Você pode usar duas ações de movimento para fazer um teleporte estendido com rank de distância igual ao rank do efeito +8. Você fica atordoado e vulnerável por uma rodada após um teleporte estendido."
          }
        }
      },
      {
        "id": "increased_mass",
        "name": "Increased Mass",
        "category": "extra",
        "costType": "flat_ranked",
        "costValue": 1,
        "description": "You can carry additional mass when you teleport equal to your rank in this extra.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Massa Aumentada",
            "description": "Você pode carregar massa adicional ao teleportar igual ao seu rank neste extra."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "medium",
        "name": "Medium",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Teleport requires passing through a specific medium (mirrors, shadows, etc.).",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Meio",
            "description": "Teleporte exige passagem por meio específico (espelhos, sombras, etc.)."
          }
        }
      },
      {
        "id": "limited_to_extended",
        "name": "Limited to Extended",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "You can only make extended teleports. You must have the Extended extra, and this flaw effectively makes it a +0 modifier.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado a Estendido",
            "description": "Você só pode fazer teleportes estendidos. Você deve ter o extra Estendido, e esta falha efetivamente o torna um modificador +0."
          }
        }
      }
    ]
  },
  {
    "id": "transform",
    "name": "Transform",
    "type": "control",
    "baseCost": 2,
    "action": "standard",
    "range": "close",
    "duration": "sustained",
    "description": "You can change objects into other objects. Requires touch (close attack if held/worn). Cost varies: 2 pts/rank (one thing into one other), 3 (broad group to single, or single to broad), 4 (broad to broad), 5 (anything to anything). Can affect mass rank (rank - 6). Inanimate objects transform automatically. Sustained: reverts when not maintained. Continuous: irreversible except by another Transform.",
    "variableCost": {
      "options": [
        {
          "name": "One to one (e.g. metal to wood)",
          "cost": 2
        },
        {
          "name": "Broad to single / Single to broad",
          "cost": 3
        },
        {
          "name": "Broad to broad (e.g. solids to solids)",
          "cost": 4
        },
        {
          "name": "Anything to anything",
          "cost": 5
        }
      ]
    },
    "i18n": {
      "pt-BR": {
        "name": "Transformação",
        "description": "Permite transformar objetos em outros objetos. Requer toque (ataque corpo a corpo se segurado/vestido). Custo varia: 2 pp/rank (um em outro), 3 (grupo amplo em único, ou único em amplo), 4 (amplo em amplo), 5 (qualquer coisa). Pode afetar massa rank (rank - 6). Objetos inanimados transformam automaticamente. Sustentado: reverte quando não mantido. Contínuo: irreversível exceto por outro Transformação."
      }
    },
    "longDescription": "You can change objects into other objects. Requires touch (close attack if held/worn). Cost varies: 2 pts/rank (one thing into one other), 3 (broad group to single, or single to broad), 4 (broad to broad), 5 (anything to anything). Can affect mass rank (rank - 6). Inanimate objects transform automatically. Sustained: reverts when not maintained. Continuous: irreversible except by another Transform.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "continuous",
        "name": "Continuous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Transformation is irreversible.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Contínuo",
            "description": "A transformação é irreversível."
          }
        }
      }
    ],
    "flaws": []
  },
  {
    "id": "variable",
    "name": "Variable",
    "type": "general",
    "baseCost": 7,
    "action": "standard",
    "range": "personal",
    "duration": "sustained",
    "description": "You can gain potentially any effect of the appropriate type and descriptor. Provides (rank x 5) power points to allocate to different effects as a standard action. Subject to power level and series limits. Must have descriptors limiting scope. If you stop maintaining, allocated points reset to null. Cannot be permanent. A 'last resort' in power design.",
    "variableCost": null,
    "i18n": {
      "pt-BR": {
        "name": "Variável",
        "description": "Permite obter potencialmente qualquer efeito do tipo e descritor apropriados. Fornece (rank x 5) pontos de poder para alocar em diferentes efeitos como ação padrão. Sujeito a limites de nível de poder e série. Deve ter descritores que limitem o escopo. Se parar de manter, os pontos alocados voltam ao estado nulo. Não pode ser permanente. É um 'último recurso' no design de poderes."
      }
    },
    "longDescription": "You can gain potentially any effect of the appropriate type and descriptor. Provides (rank x 5) power points to allocate to different effects as a standard action. Subject to power level and series limits. Must have descriptors limiting scope. If you stop maintaining, allocated points reset to null. Cannot be permanent. A 'last resort' in power design.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "action_variable",
        "name": "Action",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Change configuration faster (Move +1, Free +2, Reaction +3).",
        "subtypes": [
          {
            "id": "move",
            "label": "Move Action",
            "costValue": 1,
            "i18n": {
              "pt-BR": {
                "label": "Ação de Movimento"
              }
            }
          },
          {
            "id": "free",
            "label": "Free Action",
            "costValue": 2,
            "i18n": {
              "pt-BR": {
                "label": "Ação Livre"
              }
            }
          },
          {
            "id": "reaction",
            "label": "Reaction",
            "costValue": 3,
            "i18n": {
              "pt-BR": {
                "label": "Reação"
              }
            }
          }
        ],
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Ação",
            "description": "Muda a configuração mais rápido."
          }
        }
      },
      {
        "id": "affects_others_variable",
        "name": "Affects Others",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "You can grant effects to someone else. Affects Others Only: +0 cost per rank. Affects Others or yourself: +1 cost per rank.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Outros",
            "description": "Você pode conceder efeitos a outra pessoa. Apenas Afeta Outros: +0 custo por rank. Afeta Outros ou você mesmo: +1 custo por rank."
          }
        }
      },
      {
        "id": "perception_variable",
        "name": "Perception",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Applied to a Ranged Affects Others Variable, this extra allows you to grant the benefits of the effect to any target you can accurately perceive.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Percepção",
            "description": "Aplicado a um Variável Afeta Outros com Alcance, este extra permite conceder os benefícios do efeito a qualquer alvo que você possa perceber com precisão."
          }
        }
      },
      {
        "id": "ranged_variable",
        "name": "Ranged",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "A Variable effect with Affects Others may have the Ranged extra to improve the range at which you can grant the effect to another.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Alcance",
            "description": "Um efeito Variável com Afeta Outros pode ter o extra Alcance para melhorar a distância na qual você pode conceder o efeito a outro."
          }
        }
      }
    ],
    "flaws": [
      {
        "id": "slow",
        "name": "Slow",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Can only reconfigure outside of action time.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Lento",
            "description": "Só pode reconfigurar fora de combate."
          }
        }
      },
      {
        "id": "limited_variable",
        "name": "Limited",
        "category": "flaw",
        "costType": "per_rank",
        "costValue": -1,
        "description": "Variable effect must be even more limited than the default descriptor requirement. This is highly situational and left to the GM's judgment.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Limitado",
            "description": "O efeito Variável deve ser ainda mais limitado do que o requisito de descritor padrão. Isso é altamente situacional e fica a critério do Mestre."
          }
        }
      }
    ]
  },
  {
    "id": "weaken",
    "name": "Weaken",
    "type": "attack",
    "baseCost": 1,
    "action": "standard",
    "range": "close",
    "duration": "instant",
    "description": "You can temporarily lower one of a target's traits (chosen at acquisition) via a close attack. Target resists with Fortitude or Will vs. DC [10 + rank]. Failure: target loses power points from the trait equal to the difference (max = rank). Multiple failures are cumulative up to rank. Lost points return at 1 per round. Abilities weakened below -5 become debilitated.",
    "variableCost": null,
    "configurableFields": [
      {
        "id": "trait",
        "label": "Target Trait",
        "control": "text",
        "required": true,
        "placeholder": "e.g., Strength, Damage, Toughness",
        "i18n": {
          "pt-BR": {
            "label": "Traço Alvo",
            "placeholder": "ex: Força, Dano, Resistência"
          }
        }
      },
      {
        "id": "resistance",
        "label": "Resistance Type",
        "control": "dropdown",
        "required": true,
        "options": [
          {
            "value": "fortitude",
            "label": "Fortitude",
            "description": "Physical resistance - for physical traits"
          },
          {
            "value": "will",
            "label": "Will",
            "description": "Mental resistance - for mental traits"
          }
        ],
        "i18n": {
          "pt-BR": {
            "label": "Tipo de Resistência"
          }
        }
      }
    ],
    "i18n": {
      "pt-BR": {
        "name": "Enfraquecer",
        "description": "Permite reduzir temporariamente um dos traços de um alvo (escolhido na aquisição) por ataque corpo a corpo. O alvo resiste com Fortitude ou Vontade vs. CD [10 + rank]. Falha: o alvo perde pontos de poder do traço igual à diferença (máx. = rank). Múltiplas falhas são cumulativas até o rank. Pontos perdidos retornam a 1 por rodada. Habilidades enfraquecidas abaixo de -5 ficam debilitadas."
      }
    },
    "longDescription": "You can temporarily lower one of a target's traits (chosen at acquisition) via a close attack. Target resists with Fortitude or Will vs. DC [10 + rank]. Failure: target loses power points from the trait equal to the difference (max = rank). Multiple failures are cumulative up to rank. Lost points return at 1 per round. Abilities weakened below -5 become debilitated.",
    "enhancesDefense": null,
    "extras": [
      {
        "id": "broad",
        "name": "Broad",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Weaken any of a broad set of traits.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Amplo",
            "description": "Enfraquece qualquer um de um conjunto de traços."
          }
        }
      },
      {
        "id": "progressive",
        "name": "Progressive",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 2,
        "description": "Target continues to weaken each round until they resist.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Progressivo",
            "description": "O alvo continua a enfraquecer a cada rodada até resistir."
          }
        }
      },
      {
        "id": "simultaneous",
        "name": "Simultaneous",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "If applied to a Broad Weaken, this extra allows it to affect all of the traits in its set at the same time. Each trait loses the difference between the resistance check result and the DC in power points on a failed check. The effect must be Broad to apply this modifier.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Simultâneo",
            "description": "Se aplicado a um Enfraquecer Amplo, este extra permite afetar todos os traços do conjunto ao mesmo tempo. Cada traço perde a diferença entre o resultado do teste de resistência e a CD em pontos de poder em uma falha. O efeito deve ser Amplo para aplicar este modificador."
          }
        }
      },
      {
        "id": "affects_objects",
        "name": "Affects Objects",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Weaken with this modifier works on inanimate objects, although the effect can still only affect traits the objects possess. This is most often applied to Weaken Toughness for an effect that can weaken both creatures and objects.",
        "longDescription": "Weaken with this modifier works on inanimate objects, although the effect can still only affect traits the objects possess. This is most often applied to Weaken Toughness for an effect that can weaken both creatures and objects. +1 cost per rank, +0 for Affects Only Objects.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Afeta Objetos",
            "description": "Enfraquecer com este modificador funciona em objetos inanimados, embora o efeito ainda possa afetar apenas traços que os objetos possuem. Mais frequentemente aplicado a Enfraquecer Resistência para um efeito que pode enfraquecer criaturas e objetos."
          }
        }
      },
      {
        "id": "concentration_weaken",
        "name": "Concentration",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "Once you have hit with a Concentration Weaken, so long as you continue to take a standard action each turn to maintain the effect, the target must make a new resistance check against it, with no attack check required.",
        "longDescription": "Once you have hit with a Concentration Weaken, so long as you continue to take a standard action each turn to maintain the effect, the target must make a new resistance check against it, with no attack check required.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Concentração",
            "description": "Uma vez que você acertou com um Enfraquecer de Concentração, enquanto continuar a usar uma ação padrão a cada turno para manter o efeito, o alvo deve fazer um novo teste de resistência contra ele, sem necessidade de teste de ataque."
          }
        }
      },
      {
        "id": "incurable",
        "name": "Incurable",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "Weaken with this modifier cannot have its effects countered by another power (such as Restorative Healing) without the Persistent modifier; the target must recover from the Weaken normally.",
        "longDescription": "Weaken with this modifier cannot have its effects countered by another power (such as Restorative Healing) without the Persistent modifier; the target must recover from the Weaken normally.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Incurável",
            "description": "Enfraquecer com este modificador não pode ter seus efeitos anulados por outro poder (como Cura Restauradora) sem o modificador Persistente; o alvo deve se recuperar do Enfraquecer normalmente."
          }
        }
      },
      {
        "id": "precise_weaken",
        "name": "Precise",
        "category": "extra",
        "costType": "flat",
        "costValue": 1,
        "description": "A Weaken effect capable of reducing more than one trait at once can have this modifier, allowing you to choose which traits are affected, while not affecting others. Note this differs from the Selective extra.",
        "longDescription": "A Weaken effect capable of reducing more than one trait at once can have this modifier, allowing you to choose which traits are affected, while not affecting others. Note this differs from the Selective extra.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Preciso",
            "description": "Um efeito Enfraquecer capaz de reduzir mais de um traço de uma vez pode ter este modificador, permitindo escolher quais traços são afetados, sem afetar outros. Note que isso difere do extra Seletivo."
          }
        }
      },
      {
        "id": "selective_weaken",
        "name": "Selective",
        "category": "extra",
        "costType": "per_rank",
        "costValue": 1,
        "description": "This extra is applied to an Area Weaken so it only affects some targets and not others. Combined with Precise, you can use an Area Weaken to selectively affect only certain traits of certain targets.",
        "longDescription": "This extra is applied to an Area Weaken so it only affects some targets and not others. Combined with Precise, you can use an Area Weaken to selectively affect only certain traits of certain targets.",
        "incompatibleWith": [],
        "i18n": {
          "pt-BR": {
            "name": "Seletivo",
            "description": "Este extra é aplicado a um Enfraquecer em Área para que afete apenas alguns alvos e não outros. Combinado com Preciso, você pode usar um Enfraquecer em Área para afetar seletivamente apenas certos traços de certos alvos."
          }
        }
      }
    ],
    "flaws": []
  }
]
